import React, { useCallback, useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { useForm, Controller } from 'react-hook-form';
import { useSWRConfig } from 'swr'
import DatePicker from "react-datepicker";
import dayjs from 'dayjs'
import axios from 'axios';
import clsx from 'clsx';
import ja from "date-fns/locale/ja";
import { Oval } from 'react-loader-spinner'
import Cookies from 'universal-cookie'
import { useCookies } from 'react-cookie';
import {
  Button,
  SearchForm,
  Modal,
  Field,
  Input,
  Select,
  ButtonsWrap,
  Textarea,
  Form,
  List,
  Sidebar,
  Radio,
} from 'src/components';
import { IconMessageAdd, IconHamburger, IconMap, IconData, IconImport, IconTenant, IconUsers, IconSetting, IconUser } from 'src/icons';
import { damage_implementation, display, damage_category, prevention } from 'src/utils/choises';//230413prevention追加
import { useDrop, useEditMode, useCreateModal, useEditData, useVermins, useLineMode, useTempMove } from 'src/stores';
import { logoSite2, pagetitle } from 'src/images';
import styles from './Layout.module.scss';
import {useDropzone } from 'react-dropzone';
import Resizer from 'react-image-file-resizer';
import { Buffer } from 'buffer';
import fileDownload from 'js-file-download'; //240416 Add Uduki PDFファイルダウンロードの為
import { vermin_category,trapList,trapDisplayOrder,ecology,ecologyDisplayOrder } from 'src/utils/choises';

let File_name : string | undefined = undefined;
let page_move_check = false;

type Props = {
  children: React.ReactNode;
};

type FormValues = {
  output_format: number;
  discovery_date: Date;
  discovery_time: Date;
  vermin_kind: any;
  vermin_ecology: string;
  displayability: string;
  lat: any;
  lng: any;
  count: any;
  herd:string;
  address: string;
  remarks: string;
  trap_hunting: string;
  trap_id:number;
  camera_id:number;
  picture:File | null;
  delete: string | null;
};

type DamageFormValues = {
  implementation_date: Date | null;
  implementation_time: Date | null;
  latitude: any;
  longitude: any;
  damage_type: string;
  vermin_kind: any;
  discovery_date: Date;
  discovery_time: Date;
  contents: string;
  implementation: string;
  countermeasures: string;
  remarks: string;
  displayability: string;
  delete: string | null;
}

//230206追加
type IndpinFormValues = {
  label: string;
  latitude: any;
  longitude: any;
  comment: string; // 20250417 Add Uduki
  displayability: string;
  delete: string | null;
}

//230314追加
type TrapFormValues = {
  trap_hunting: string;
  vermin_kind: any;
  trap_start: Date;
  trap_stop: Date;
  latitude: any;
  longitude: any;
  address: string;
  log_lat: any;
  log_lon: any;
  count: any;
  admin: string;
  admin_tel: string;
  result: string;
  mistake: string | null;
  mistake_log: string;
  camera_id: any;
  remarks: string;
  displayability: string;
  delete: string | null;
}

//230314追加
type CameraFormValues = {
  camera_start: Date;
  camera_stop: Date;
  latitude: any;
  longitude: any;
  direction: string;
  trap_id: any;
  remarks: string;
  displayability: string;
  delete: string | null;
}

//230413追加
type PrevFormValues = {
  id: number | null;
  type_name: string;
  delivery_year: string;
  delivery_date: Date;
  admin: string;
  admin_tel: string;
  adress: string;
  distance: string;
  geom_text: string;
  remarks: string;
  displayability: string;
  delete: string | null;
}

//20240410報告書情報追加
type ReportFormValues = {
  report_kind: number;
  information_id: number;

  report_dt: Date | null;
  receptionist_nm: string;
  reporter_nm: string;
  waypoint: string;
  receptionist_dt: Date | null;
  receptionist_tm: Date | null;

  report_nm: string;
  report_tel: string;
  discovery_dt: Date | null;
  discovery_tm: Date | null;
  discovery_address: string;
  latitude: any;
  longitude: any;
  administrative_district: string;
  vermin_kind_id:any;
  vermin_nm: string;
  head_count: any;
  ecology: any;
  report_st: string;

  confirmation_dt: Date | null;
  confirmation_tm: Date | null;
  confirmer: string;
  witness: string;
  witness_tel: string;
  zoning: any;
  zoning_st: string;

  contact_rp: string;

  hdamage_nt: string;
  crop_nm: string;
  crop_ps: any;
  new_crop_ps: string[];
  crop_co: string;
  crop_ar: string;
  crop_nt: string;
  digging_up_dp: any;
  digging_up_nt: string;
  damage_other: string;

  attachKind: string;
  new_attachKind: string[];
  attach_other_r: string;

  remarks: string;
}

type FormErrors = {
  vermin_kind: [],
  discovery_date: [],
  discovery_time: [],
  implementation_date: [],
  implementation_time: [],
  // 20240410 Add Uduki
  report_dt: [],
  discovery_dt: [],
  discovery_tm: [],
  receptionist_dt: [],
  receptionist_tm: [],
  confirmation_dt: [],
  confirmation_tm: [],
  // 20240410 Add Uduki
}

type LoginFormValues = {
  password: string;
  userId: string;
}

const Layout: React.FC<Props> = ({ children }) => {
  /**
* 害獣新規登録修正フォームを管理するカスタムフック
* register を適用したフィールドの値を handleSubmit で取得できる
* See https://react-hook-form.com/api/useform
* @example
* <Form onSubmit={handleSubmit(submit)}>
*   <input {...register('field_name')} />
*   ...
* </Form>
*/
  const { register, control, watch, handleSubmit, setValue, reset,formState: { errors: verminErrors } } = useForm<FormValues>();

  /**
  * 被害新規登録修正フォームを管理するカスタムフック
  * damageRegister を適用したフィールドの値を damageSubmit で取得できる
  * See https://react-hook-form.com/api/useform
  * @example
  * <Form onSubmit={damageSubmit(submit)}>
  *   <input {...damageRegister('field_name')} />
  *   ...
  * </Form>
  */
  const { register: damageRegister, control: damageControl, watch: damageWatch, handleSubmit: damageSubmit, setValue: damageSetValue, reset: damageReset, formState: { errors: damageErrors } } = useForm<DamageFormValues>();

  /**
* ログインフォームを管理するカスタムフック
* loginRegister を適用したフィールドの値を loginSubmit で取得できる
* See https://react-hook-form.com/api/useform
* @example
* <Form onSubmit={loginSubmit(submit)}>
*   <input {...loginRegister('field_name')} />
*   ...
* </Form>
*/
  const { handleSubmit: loginSubmit, register: loginRegister, reset: loginReset, formState: { errors: loginErrors } } = useForm<LoginFormValues>();

/**
  * 230206追記
  * 指示ピン新規登録修正フォームを管理するカスタムフック
  * indpinRegister を適用したフィールドの値を indpinSubmit で取得できる
  * See https://react-hook-form.com/api/useform
  * @example
  * <Form onSubmit={indpinSubmit(submit)}>
  *   <input {...indpinRegister('field_name')} />
  *   ...
  * </Form>
  */
    const { register: indpinRegister, control: indpinControl, watch: indpinWatch, handleSubmit: indpinSubmit, setValue: indpinSetValue, reset: indpinReset, formState: { errors: indpinErrors } } = useForm<IndpinFormValues>();

/**
  * 230314追記
  * 罠新規登録修正フォームを管理するカスタムフック
  * trapRegister を適用したフィールドの値を trapSubmit で取得できる
  * See https://react-hook-form.com/api/useform
  * @example
  * <Form onSubmit={trapSubmit(submit)}>
  *   <input {...trapRegister('field_name')} />
  *   ...
  * </Form>
  */
const { register: trapRegister, control: trapControl, watch: trapWatch, handleSubmit: trapSubmit, setValue: trapSetValue, reset: trapReset, formState: { errors: trapErrors } } = useForm<TrapFormValues>();

/**
  * 230315追記
  * カメラ新規登録修正フォームを管理するカスタムフック
  * cameraRegister を適用したフィールドの値を cameraSubmit で取得できる
  * See https://react-hook-form.com/api/useform
  * @example
  * <Form onSubmit={cameraSubmit(submit)}>
  *   <input {...cameraRegister('field_name')} />
  *   ...
  * </Form>
  */
const { register: cameraRegister, control: cameraControl, watch: cameraWatch, handleSubmit: cameraSubmit, setValue: cameraSetValue, reset: cameraReset, formState: { errors: cameraErrors } } = useForm<CameraFormValues>();

/**
  * 230413追記
  * 防止施設新規登録修正フォームを管理するカスタムフック
  * cameraRegister を適用したフィールドの値を prevSubmit で取得できる
  * See https://react-hook-form.com/api/useform
  * @example
  * <Form onSubmit={prevSubmit(submit)}>
  *   <input {...prevRegister('field_name')} />
  *   ...
  * </Form>
  */
const { register: prevRegister, control: prevControl, watch: prevWatch, handleSubmit: prevSubmit, setValue: prevSetValue, reset: prevReset, formState: { errors: prevErrors } } = useForm<PrevFormValues>();
//防止施設位置方法エラー表示用
const Line_Error = document.getElementById("Line_Error");

/**
  * 20240410追記
  * 報告書編集フォームを管理するカスタムフック
  * reportRegister を適用したフィールドの値を reportSubmit で取得できる
  * See https://react-hook-form.com/api/useform
  * @example
  * <Form onSubmit={reportSubmit(submit)}>
  *   <input {...reportRegister('field_name')} />
  *   ...
  * </Form>
  */
const { register: reportRegister, control: reportControl, watch: reportWatch, handleSubmit: reportSubmit, setValue: reportSetValue, reset: reportReset, formState: { errors: reportErrors } } = useForm<ReportFormValues>();

  /**
 * 害獣被害新規登録修正で用いるデータ群
 * verminData, damageData, indpinData, trapData reportData: 修正時の目的データを格納しておく
 * deleteEditVerminData, deleteEditDamageData, deleteEditIndpinData, deleteEditTrapData deleteEditReportData: 登録後、修正に使ったverminData,damageDataを削除する
 * latLng, deleteLatLng: マップ上からの新規登録時、緯度経度を格納、消去する
 * 20240410 AddUduki 報告書用データ呼び出し処理追加 reportData deleteEditReportData
 */
  const [verminData, damageData, indpinData, trapData, cameraData, prevData, reportData, expPictureData, 
         deleteEditVerminData, deleteEditDamageData, deleteEditIndpinData, deleteEditTrapData, deleteEditCameraData, deleteEditPrevData,  deleteEditReportData, deleteexpPictureData, latLng, deleteLatLng, Line, deleteLine, Page, setPage, deletePage,
         setEditReportData] = useEditData(
    state => [state.verminData, state.damageData, state.indpinData, state.trapData, state.cameraData, state.prevData, state.reportData, state.expPictureData, 
              state.deleteEditVerminData, state.deleteEditDamageData, state.deleteEditIndpinData, state.deleteEditTrapData, state.deleteEditCameraData, state.deleteEditPrevData, state.deleteEditReportData, state.deleteexpPictureData, state.latLng, state.deleteLatLng, state.Line, state.deleteLine, state.Page, state.setPage, state.deletePage,
              state.setEditReportData]);

  const [dropClose, isDroped] = useDrop(state => [state.dropClose, state.isDroped]);

/**
* 新規情報登録ハンドラ
* レポート登録ハンドラOpen Close 追加　20240416 Add Uduki
*/
  const [createModalClose, createDamageModalClose, createIndpinModalClose, createTrapModalClose, createCameraModalClose, createPrevModalClose, createPictureModalClose, createReportModalClose, 
         isCreateModal, isCreateDamageModal, isCreateIndpinModal, isCreateTrapModal, isCreateCameraModal, isCreatePrevModal, isExpPictureModal, isCreateReportModal,
         createReportModalOpen] = useCreateModal(
    state => [state.createModalClose, state.createDamageModalClose, state.createIndpinModalClose, state.createTrapModalClose, state.createCameraModalClose, state.createPrevModalClose, state.createPictureModalClose, state.createReportModalClose,
              state.isCreateModal, state.isCreateDamageModal, state.isCreateIndpinModal, state.isCreateTrapModal, state.isCreateCameraModal, state.isCreatePrevModal, state.isExpPictureModal, state.isCreateReportModal,
              state.createReportModalOpen]);

/**
* 新規情報登録ハンドラ
*/
  const [setVermins, setIds, setProc, searchCondition, deleteSearchCondition, searchCheck] = useVermins(state => [state.setVermins, state.setIds, state.setProc, state.searchCondition, state.deleteSearchCondition, state.searchCheck]);

  /**
 * 編集モードの起動
 */
  const [setEditModeToggle, setEditModeClose] = useEditMode(state => [state.setEditModeToggle, state.setEditModeClose]);
/**
 * 線編集モードの起動
 */
  const [setLineModeToggle] = useLineMode(state => [state.setLineModeToggle]);

  /**
   * Cookie
   */
  const [cookie, setCookie, removeCookie] = useCookies();

  /**
   * ページ遷移Navigate
   */
  const navigate = useNavigate();

  /**
   * 情報登録API完了後にマーカーの情報を更新する
   */
  const { mutate } = useSWRConfig();

  /**
   * ページ遷移（stateも消したいとき）
   */
  const location = useLocation();

  /**
 * 削除Cookie用
 */
  const cookies = new Cookies();

  /**
   * ログアウトモーダルの出現フラグ
   */
  const [isLogoutModal, setIsLogoutModal] = useState(false);

  /**
   * login失敗時のエラーメッセージが入る
   */
  const [loginError, setLoginError] = useState<any>();

  /**
* API通信中判定フラグ
*/
  const [loading, setLoading] = useState(false);

  /**
   * 害獣被害情報新規登録・修正の際に生じるエラーを格納
   */
  const [errors, setErrors] = useState<FormErrors>();

  /**
 * 一時的ページ移動フラグ 2023/4/17追記
 */
  const [trueT_M] = useTempMove(state => [state.trueT_M]);

  /**
   * サイドバーの開閉状態
   * - true 表示
   * - false 非表示
   * @example
   * setSidebarVisible(!sidebarVisible);
   */
  const [sidebarVisible, setSidebarVisible] = useState(false);

  //画像ファイルのリサイズ処理20230411画像用
  const resizeFile = (file: Blob,wid:number,hei: number) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        wid,
        hei,
        'JPEG',
        80,
        0,
        (uri) => {
          resolve(uri as String);
        },
        'base64',
      );
    });

  // useState()で画像のパスを保持テスト用
  // ※デフォルトで表示する画像を初期値で指定(publicフォルダのblank.pngを指定)
  const [profileImage, setProfileImage] = useState('blank.png');
  // useState()で画像のパスを保持テスト用
  // ※デフォルトで表示する画像を初期値で指定(publicフォルダのblank.pngを指定)
  const [ExpImage,setExpImage] = useState('blank.png');

//画像ファイルのドロップ&ドラックの設定
  const onDrop = useCallback((files: File[]) => {
    if(watch('picture')!==null){
      setValue('picture', null);
    }
    if (files.length > 0) {
      // `imagesize()` で `File` オブジェクトの幅・高さが取得できる
      imagesize(files[0]).then((result) => {
        if(Array.isArray(result)){
          let wid = result[0];
          let hei = result[1];
          const limit_size = Number(`${process.env.REACT_APP_IMAGE_RECORD_LIMIT_SIZE}`);
          const product_size = wid*hei;
          if(product_size > limit_size){
            const magnification = Math.sqrt(limit_size/product_size);
            wid = Math.floor(wid*magnification);
            hei = Math.floor(hei*magnification);
          }
          resizeFile(files[0],wid,hei).then((result2) => {
            //console.log(result2);
            if(typeof(result2)==="string" && result2 != null){
              const fileData =result2.replace(/^data:\w+\/\w+;base64,/, '');
              // const decodedFile = Buffer.from(fileData, 'base64');
              const decodedFile = Uint8Array.from(atob(fileData), c => c.charCodeAt(0));
              const file = new File([decodedFile], files[0].name, { type: 'image/jpeg' });
              // オブジェクトURLを生成し、useState()を更新
              setProfileImage(window.URL.createObjectURL(file));
              setValue("picture",file);
            }
          });
        }
      });
      //setValue("picture",files[0]);
      File_name = files[0].name;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'image/png': ['.png', '.jpg', '.jpeg'],
    },
  });
  const picture_delate = useCallback(() => {
    setValue('picture',null);
    File_name = undefined;
    setProfileImage('blank.png');
  }, [File_name]);
  /**
   * アップロードされた画像のサイズを確認
   */
  const imagesize = (file: File) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const width = img.naturalWidth;
        const height = img.naturalHeight;
        URL.revokeObjectURL(img.src);
        img.width = 200;
			  img.height = 200;
        resolve([width,height]);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = URL.createObjectURL(file);
    });
  }
  
  /**
   * react-hook-formのdefaultValuesではキャッシュが残るため初期値がうまく入らない
   * verminData,damageData,latLngがすでにデータを持つ場合、各フォームに値を格納
   */
  useEffect(() => {
    trap_display("新規");
    deletePage();//20230413追記
    if (cookie?.verminData?.user_kind_id === 2) {
      setValue('displayability', '管理者公開');
      setValue('discovery_date', new Date());
      setValue('discovery_time', new Date());
      damageSetValue('displayability', '管理者公開');
      damageSetValue('discovery_date', new Date());
      damageSetValue('discovery_time', new Date());
      trapSetValue('displayability', '管理者公開');
      cameraSetValue('displayability', '管理者公開');
      indpinSetValue('displayability', '管理者公開');
      prevSetValue('displayability', '管理者公開');//20230413追記
    }
    //マップ上からの新規作成時
    if (latLng) {
      setValue('lat', latLng?.lat);
      setValue('lng', latLng?.lng);
      damageSetValue('latitude', latLng?.lat);
      damageSetValue('longitude', latLng?.lng);
      indpinSetValue('latitude', latLng?.lat);
      indpinSetValue('longitude', latLng?.lng);
      trapSetValue('latitude', latLng?.lat);
      trapSetValue('longitude', latLng?.lng);
      cameraSetValue('latitude', latLng?.lat);
      cameraSetValue('longitude', latLng?.lng);
    }
    //害獣データ修正時
    else if (verminData) {
      const date = verminData.vermin_discovery_date ? new Date(dayjs(`${verminData.vermin_discovery_date} ${verminData.vermin_discovery_time}`).format()) : new Date();
      setValue('discovery_date', date);
      setValue('discovery_time', date);
      setValue('vermin_kind', verminData?.vermin_kind_id);
      setValue('vermin_ecology', verminData?.vermin_ecology_name);
      setValue('displayability', verminData?.vermin_displayability_name);
      setValue('lat', verminData?.vermin_latitude);
      setValue('lng', verminData?.vermin_longitude);
      setValue('count', verminData?.vermin_count);
      setValue('herd', verminData?.vermin_herd);
      setValue('trap_hunting', verminData?.trap_hunting_name);
      setValue('trap_id', verminData?.trap_id);
      setValue('camera_id', verminData?.camera_id);
      setValue('address', verminData?.vermin_address);
      setValue('remarks', verminData?.vermin_remarks);
      trap_display(verminData?.vermin_ecology_name);
      //画像登録用20230407追記
      File_name = verminData?.vermin_picture;
      if(verminData?.vermin_picture){
        setProfileImage(`${process.env.REACT_APP_DEV_IMAGE}/vermin/${verminData?.vermin_picture}`);
      }
    }
    //被害データ修正時
    else if (damageData) {
      const discovery_date = damageData.damage_discovery_date ? new Date(dayjs(damageData.damage_discovery_date).format()) : new Date();
      const implementation_date = damageData.damage_implementation_date ? new Date(dayjs(damageData.damage_implementation_date).format()) : null;
      damageSetValue('discovery_date', discovery_date);
      damageSetValue('discovery_time', discovery_date);
      if (implementation_date) {
        damageSetValue('implementation_date', implementation_date);
        damageSetValue('implementation_time', implementation_date);
      }
      damageSetValue('vermin_kind', damageData?.vermin_kind_id);
      damageSetValue('damage_type', damage_category[+damageData?.damage_type_id]);
      damageSetValue('contents', damageData?.damage_contents);
      damageSetValue('latitude', damageData?.damage_latitude);
      damageSetValue('longitude', damageData?.damage_longitude);
      damageSetValue('countermeasures', damageData?.damage_countermeasures);
      damageSetValue('implementation', damage_implementation[+damageData?.damage_implementation]);
      damageSetValue('remarks', damageData?.damage_remarks);
      damageSetValue('displayability', display[+damageData?.damage_displayability]);
    }
    //指示ピンデータ修正時 230206追加
    else if (indpinData) {
      indpinSetValue('label', indpinData?.indpin_label);
      indpinSetValue('latitude', indpinData?.indpin_latitude);
      indpinSetValue('longitude', indpinData?.indpin_longitude);
      indpinSetValue('comment', indpinData?.indpin_comment); // 20250417 Add Uduki
      indpinSetValue('displayability', display[+indpinData?.indpin_displayability]);
    }
    //罠データ修正時 230214追加
    else if (trapData) {
      const start_d = trapData.trap_start ? new Date(dayjs(`${trapData.trap_start}`).format()) : new Date();
      const stop_d = trapData.trap_stop ? new Date(dayjs(`${trapData.trap_stop}`).format()) : new Date();
      const miss = trapData.trap_mistake ? "mistake" : null ;
      trapSetValue('trap_hunting', String(trapData?.trap_hunting_id));
      trapSetValue('vermin_kind', trapData?.vermin_kind_id);
      if (start_d) {
        trapSetValue('trap_start', start_d);
      }
      if(stop_d){
        trapSetValue('trap_stop', stop_d);
      }
      trapSetValue('latitude', trapData?.trap_latitude);
      trapSetValue('longitude', trapData?.trap_longitude);
      trapSetValue('address', trapData?.trap_address);
      trapSetValue('log_lat', trapData?.trap_log_latitude);
      trapSetValue('log_lon', trapData?.trap_log_longitude);
      trapSetValue('count', trapData?.trap_count);
      trapSetValue('admin', trapData?.trap_admin);
      trapSetValue('admin_tel', trapData?.trap_admin_tel);
      trapSetValue('result', trapData?.trap_result);
      trapSetValue('mistake', miss);
      trapSetValue('mistake_log', trapData?.trap_mistake_log);
      trapSetValue('camera_id', trapData?.camera_id);
      trapSetValue('remarks', trapData?.trap_remarks);
      trapSetValue('displayability', display[+trapData?.trap_displayability]);
    }
    //カメラデータ修正時 230215追加
    else if (cameraData) {
      const start_d = cameraData.camera_start ? new Date(dayjs(`${cameraData.camera_start}`).format()) : new Date();
      const stop_d = cameraData.camera_stop ? new Date(dayjs(`${cameraData.camera_stop}`).format()) : new Date();
      if (start_d) {
        cameraSetValue('camera_start', start_d);
      }
      if(stop_d){
        cameraSetValue('camera_stop', stop_d);
      }
      cameraSetValue('latitude', cameraData?.camera_latitude);
      cameraSetValue('longitude', cameraData?.camera_longitude);
      cameraSetValue('direction', cameraData?.camera_direction);
      cameraSetValue('trap_id', cameraData?.trap_id);
      cameraSetValue('remarks', cameraData?.camera_remarks);
      cameraSetValue('displayability', display[+cameraData?.camera_displayability]);
    }
    else if (prevData) {
      const start_d = prevData.prev_faci_delivery_date ? new Date(dayjs(`${prevData.prev_faci_delivery_date}`).format()) : new Date();
      prevSetValue('id',prevData.prev_faci_id);
      prevSetValue('type_name', prevention[+prevData.prev_faci_type_id]);
      if (start_d) {
        prevSetValue('delivery_date', start_d);
      }
      prevSetValue('delivery_year', prevData?.prev_faci_delivery_year);
      prevSetValue('admin', prevData?.prev_faci_admin);
      prevSetValue('admin_tel', prevData?.prev_faci_admin_tel);
      prevSetValue('adress', prevData?.prev_faci_adress);
      prevSetValue('distance', prevData?.prev_faci_distance);
      prevSetValue('remarks', prevData?.prev_faci_remarks);
      prevSetValue('displayability', display[+prevData?.prev_faci_displayability]);
      prevSetValue('geom_text', "更新");
      setPage("/Data");//20230413追記
      deleteEditPrevData();
    }
    //報告書データ修正時
    else if (reportData) {

      const report_dt = reportData.report_dt ? new Date(dayjs(reportData.report_dt).format()) : new Date();
      const receptionist_dt = reportData.receptionist_ts ? new Date(dayjs(reportData.receptionist_ts).format()) : null;
      const discovery_dt = reportData.discovery_ts ? new Date(dayjs(reportData.discovery_ts).format()) : null;
      const confirmation_dt = reportData.confirmation_ts ? new Date(dayjs(reportData.confirmation_ts).format()) : null;
      
      reportSetValue('report_kind', reportData?.report_kind);
      reportSetValue('information_id', reportData?.information_id);

      if (report_dt) {
        reportSetValue('report_dt', report_dt);
      }
      reportSetValue('receptionist_nm', reportData?.receptionist_nm);
      reportSetValue('reporter_nm', reportData?.reporter_nm);
      reportSetValue('waypoint', reportData?.waypoint);
      if (receptionist_dt) {
        reportSetValue('receptionist_dt', receptionist_dt);
        reportSetValue('receptionist_tm', receptionist_dt);
      }

      reportSetValue('report_nm', reportData?.report_nm);
      reportSetValue('report_tel', reportData?.report_tel);
      if (discovery_dt) {
        reportSetValue('discovery_dt', discovery_dt);
        reportSetValue('discovery_tm', discovery_dt);
      }
      reportSetValue('discovery_address', reportData?.discovery_address);
      reportSetValue('latitude', reportData?.latitude);
      reportSetValue('longitude', reportData?.longitude);
      reportSetValue('administrative_district', reportData?.administrative_district);
      reportSetValue('vermin_kind_id', reportData?.vermin_kind_id);
      reportSetValue('vermin_nm', reportData?.vermin_nm);
      reportSetValue('head_count', reportData?.head_count);
      reportSetValue('ecology', reportData?.ecology);
      reportSetValue('report_st', reportData?.report_st);

      if (confirmation_dt) {
        reportSetValue('confirmation_dt', confirmation_dt);
        reportSetValue('confirmation_tm', confirmation_dt);
      }
      reportSetValue('confirmer', reportData?.confirmer);
      reportSetValue('witness', reportData?.witness);
      reportSetValue('witness_tel', reportData?.witness_tel);
      reportSetValue('zoning', reportData?.zoning);
      reportSetValue('zoning_st', reportData?.zoning_st);

      reportSetValue('contact_rp', reportData?.contact_rp);

      reportSetValue('hdamage_nt', reportData?.hdamage_nt);
      reportSetValue('crop_nm', reportData?.crop_nm);
      const new_crop_ps = [];
      const crop_ps = reportData?.crop_ps;
      if(crop_ps == 1 || crop_ps == 3){ new_crop_ps.push('1'); }
      if(crop_ps == 2 || crop_ps == 3){ new_crop_ps.push('2'); }
      reportSetValue('new_crop_ps', new_crop_ps);
      reportSetValue('crop_co', reportData?.crop_co);
      reportSetValue('crop_ar', reportData?.crop_ar);
      reportSetValue('crop_nt', reportData?.crop_nt);
      reportSetValue('digging_up_dp', reportData?.digging_up_dp);
      reportSetValue('digging_up_nt', reportData?.digging_up_nt);
      reportSetValue('damage_other', reportData?.damage_other);

      const new_attach = [];
      const attach_kind = reportData?.attachKind;
      if(/^..1$/.test(attach_kind)){ new_attach.push('1'); }
      if(/^.1.$/.test(attach_kind)){ new_attach.push('2'); }
      if(/^1..$/.test(attach_kind)){ 
        new_attach.push('4');
        document.getElementById("attach_other")!.style.display = "block";
      }else{ document.getElementById("attach_other")!.style.display = "none"; }
      reportSetValue('new_attachKind', new_attach);
      reportSetValue('attach_other_r', reportData?.attach_other_r);

      reportSetValue('remarks', reportData?.remarks);
    }
    //画像拡大表示時 230411追加
    else if (expPictureData){
      //console.log(expPictureData);
      setExpImage(`${process.env.REACT_APP_DEV_IMAGE}/vermin/${expPictureData}`);
    }
    //管理データからの新規作成時
    else {
      setValue('discovery_date', new Date());
      setValue('discovery_time', new Date());
      damageSetValue('discovery_date', new Date());
      damageSetValue('discovery_time', new Date());
      setPage("/Data");//20230413追記
    }
  }, [latLng, verminData, damageData, indpinData, trapData, cameraData, reportData, prevData, expPictureData, isCreateModal, isCreateDamageModal, isCreateIndpinModal, isCreateTrapModal, isCreateCameraModal, isCreatePrevModal, isCreateReportModal,isExpPictureModal]);

  /**
 * ログアウト時処理
 */
  const handleLogout = useCallback(() => {
    axios.get(`${process.env.REACT_APP_DEV_API_URL}/logout`, { headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}`, Accept: 'application/json' } }).then(async () => {
      await setVermins([]);
      await setIds([]);
      await setProc("");
      await removeCookie('verminData');
      await navigate("/");
      await setEditModeClose();
    }).catch(async err => {
      //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
      if (err?.response?.data?.message === "Unauthenticated.") {
        await setVermins([]);
        await setIds([]);
        await setProc("");
        await cookies.remove('verminData');
        await window.location.replace('/');
      }
    })
  }, [cookie?.verminData?.api_token, navigate, removeCookie])

  /**
   * 「情報新規登録」のモーダルを開閉するハンドラ
   * @example
   * <Button onClick={handleRegistrationModalToggle}>...</Button>
   */
  const handleRegistrationModalToggle = useCallback(() => {
    deleteEditVerminData();
    reset();
    //画像登録用20230407追記
    File_name = undefined;
    createModalClose();
    deleteLatLng();
  }, [createModalClose, deleteEditVerminData, deleteLatLng, reset]);

  /**
   * 「被害情報新規登録」のモーダルを開閉するハンドラ
   * @example
   * <Button onClick={handleCreateDamageModalClose}>...</Button>
   */
  const handleCreateDamageModalClose = useCallback(() => {
    deleteEditDamageData();
    damageReset();
    createDamageModalClose();
    deleteLatLng();
  }, [createDamageModalClose, damageReset, deleteEditDamageData, deleteLatLng]);

  /**
   * 「指示ピン情報新規登録」のモーダルを開閉するハンドラ
   * @example
   * <Button onClick={handleCreateDamageModalClose}>...</Button>
   */
  const handleCreateIndpinModalClose = useCallback(() => {
    deleteEditIndpinData();
    indpinReset();
    createIndpinModalClose();
    deleteLatLng();
  }, [createIndpinModalClose, indpinReset, deleteEditIndpinData, deleteLatLng]);

  /**
   * 「トラップ情報新規登録」のモーダルを開閉するハンドラ
   * @example
   * <Button onClick={handleCreateTrapModalClose}>...</Button>
   */
    const handleCreateTrapModalClose = useCallback(() => {
      deleteEditTrapData();
      trapReset();
      createTrapModalClose();
      deleteLatLng();
    }, [createTrapModalClose, trapReset, deleteEditTrapData, deleteLatLng]);

  /**
   * 「カメラ情報新規登録」のモーダルを開閉するハンドラ
   * @example
   * <Button onClick={handleCreateCameraModalClose}>...</Button>
   */
  const handleCreateCameraModalClose = useCallback(() => {
    deleteEditCameraData();
    cameraReset();
    createCameraModalClose();
    deleteLatLng();
  }, [createCameraModalClose, cameraReset, deleteEditCameraData, deleteLatLng]);

  /**
   * 「防止施設情報新規登録」のモーダルを開閉するハンドラ20230413追記
   * @example
   * <Button onClick={handleCreatePrevModalClose}>...</Button>
   */
    const handleCreatePrevModalClose = useCallback(() => {
      if(Line_Error){
        Line_Error.innerHTML = " ";
      }
      deleteEditPrevData();
      prevReset();
      createPrevModalClose();
      deleteLatLng();
      deleteLine();
      deletePage();
    }, [createPrevModalClose, prevReset, deleteEditPrevData, deleteLatLng, deleteLine, deletePage]);
  /**
   * 「防止施設位置情報登録」のモーダルを開閉するハンドラ20230413追記
   * @example
   * <Button onClick={prevOpenLine}>...</Button>
   */
      const prevOpenLine = useCallback(() => {
        if(Line_Error){
          Line_Error.innerHTML = " ";
        }
        if(Page){
          setVermins([]);
          trueT_M();
          page_move_check = true;
          navigate("/");
        }
        setLineModeToggle();
        createPrevModalClose();
      }, [setLineModeToggle,createPrevModalClose,Page,page_move_check,navigate]);
      //一括削除
      const prevCloseLine = useCallback(() => {
        deleteLine();
      }, [deleteLine]);

    /**
   * 「拡大画像表示」のモーダルを開閉するハンドラ/画像登録用20230411追記
   * @example
   * <Button onClick={handlePictureModalToggle}>...</Button>
   */
    const handlePicturenModalToggle = useCallback(() => {
      deleteexpPictureData();
      setExpImage(`${process.env.REACT_APP_DEV_IMAGE}/blank.png`);
      createPictureModalClose();
    }, [createPictureModalClose,deleteexpPictureData]);

  /**
   * 「有害鳥獣出没現地確認報告書編集」のモーダルを開閉するハンドラ
   * @example
   * <Button onClick={handleCreateDamageModalClose}>...</Button>
   */
  const handleCreateReportModalClose = useCallback(() => {
    deleteEditReportData();
    reportReset();
    createReportModalClose();
    deleteLatLng();
  }, [createReportModalClose, reportReset, deleteEditReportData, deleteLatLng]);

  /**
   * ログイン処理ハンドラ
   */
  const handleLogin = useCallback((data: any) => {
    axios.post(`${process.env.REACT_APP_DEV_API_URL}/login`, {
      user_login_id: data.userId,
      password: data.password,
    }).then(async (data) => {
      if (data?.data?.errors) {
        setLoginError(data?.data?.errors);
      } else {
        setLoginError('');
        await setCookie('verminData', data.data);
      }
    }).catch((err) => {
      setLoginError(err?.response?.data?.errors)
    });
  }, [])

  /**
   * submitイベントのコールバック関数
   * @example
   * handleSubmit(search)
   */
  const search = async (data: any) => {
    //Loading表示
    setLoading(true);
    const start_date = data.start_date && dayjs(data.start_date).format("YYYY/MM/DD");
    const end_date = data.end_date && dayjs(data.end_date).format('YYYY/MM/DD');
    const occurrence_start = data.occurrence_start && dayjs(data.occurrence_start).format('HH:mm');
    const occurrence_stop = data.occurrence_stop && dayjs(data.occurrence_stop).format('HH:mm');
    const kinds_vermin = (data.category === 'vermin' || data.category === 'damage' || data.category === 'trap') ? data.kinds_vermin : undefined;
    const displayability = data.displayability;
    const report_exist = data.report_exist; //20240417 Add Uduki
    await axios.get(`${process.env.REACT_APP_DEV_API_URL}/search-data/${data.category}`,
      {
        params: {
          kinds_vermin,
          start_date,
          end_date,
          client_code: cookie?.verminData?.client_code,
          start_time: occurrence_start,
          end_time: occurrence_stop,
          //management_search: cookie.verminData.user_kind_id === 2 ? 'value' : null,
          management_search: 'TRUE',
          report_exist, //20240417 Add Uduki
          displayability: cookie?.verminData?.user_kind_id === 3 ? displayability : null,
        }, headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}` }
      }).then((data) => {
        //管理データからの登録があった場合、再検索(fetch)
        if (location.pathname !== "/" && !page_move_check) {
          setVermins(data?.data?.results);
          setIds(data?.data?.ids);
        }else if (page_move_check){
          page_move_check = false;
        }
      }).catch(async err => {
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      })
    //通信完了後Loading非表示
    setLoading(false)
  };

  /**
   * マップ上のサーチイベントのコールバック関数
   * @example
   */
  const mapsearch = async (data: any) => {
    //Loading表示
    setLoading(true);
    const start_date = data.start_day && dayjs(data.start_day).format("YYYY/MM/DD")
    const end_date = data.end_day && dayjs(data.end_day).format('YYYY/MM/DD')
    const start_time = data.start_time && dayjs(data.start_time).format('HH:mm')
    const end_time = data.end_time && dayjs(data.end_time).format('HH:mm')
    const word = data.keyword.trim().split(/\s+/).join();
    const proc = data.proc;
    axios.get(`${process.env.REACT_APP_DEV_API_URL}/search-data/${proc}`, {
        params: {
          word,
          start_date,
          end_date,
          start_time,
          end_time,
          client_code: cookie?.verminData?.client_code,
          time_zone: data.time_zone?.join(''),
        },
        headers: { Authorization: `Bearer ${cookie?.verminData?.api_token}` }
      },
      ).then((data) => {
        setVermins(data.data.results);
        setProc(proc);
        setIds(data.data.ids);
      }).catch(async err => {
        if (err?.response?.data?.message === "Unauthenticated.") {
          await cookies.remove('verminData');
          await window.location.replace('/')
        }
    })
      setLoading(false)
  };

  /**
   * 害獣情報新規登録修正
   * @param data
   */
  const registerVermin = (data: FormValues) => {
    setLoading(true)
    if (verminData) {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/update-vermin`, {
        id: verminData?.vermin_id,
        vermin_kind: data.vermin_kind,
        vermin_ecology: data.vermin_ecology,
        discovery_date: dayjs(data.discovery_date).format('YYYY/MM/DD'),
        discovery_time: dayjs(data.discovery_time).format('HH:mm'),
        latitude: data.lat,
        longitude: data.lng,
        address: data.address,
        count: data.count,
        herd: data.herd,
        trap_hunting: data.trap_hunting,
        trap_id: data.trap_id,
        camera_id: data.camera_id,
        displayability: data.displayability,
        vermin_picture: data.picture,//画像登録用20230411追記
        vermin_picture_name: File_name,//画像登録用20230411追記
        remarks: data.remarks,
        delete: watch("delete") === "delete" ? '[]' : null,
        delete_id: watch("delete") === "delete" ? verminData?.vermin_id : null,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`,
          'content-type': 'multipart/form-data',
        }
      }).then(async (res) => {
        const v_id = verminData?.vermin_id;
        const delete_check = watch("delete") === "delete";
        setErrors(res?.data?.errors);
        deleteEditVerminData();
        reset();
        File_name = undefined;//画像登録用20230411追記
        damageReset();
        createModalClose();
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/vermin-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }
        else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
        // ↓ 20240416 Add Uduki 続けてレポートを登録する
        if(cookie?.verminData?.user_kind_id === 3 && !delete_check){
          var result = window.confirm('続けて報告書の情報を登録しますか？');
          if(result){
            open_report_modal(1, v_id);
          }
        }
        // ↑ 20240416 Add Uduki 続けてレポートを登録する
      }
      ).catch(async (err) => {
        setLoading(false)
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
      //↓新規登録時
    } else {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/register-vermin`, {
        vermin_kind: data.vermin_kind,
        vermin_ecology: data.vermin_ecology,
        discovery_date: dayjs(data.discovery_date).format('YYYY/MM/DD'),
        discovery_time: dayjs(data.discovery_time).format('HH:mm'),
        latitude: data.lat,
        longitude: data.lng,
        address: data.address,
        count: data.count,
        herd: data.herd,
        trap_hunting: data.trap_hunting,
        trap_id: data.trap_id,
        camera_id: data.camera_id,
        vermin_picture: data.picture,//画像登録用20230411追記
        displayability: data.displayability,
        remarks: data.remarks,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`,
          'content-type': 'multipart/form-data',
        }
      }).then(async (res) => {
        setErrors(res?.data?.errors);
        deleteEditVerminData();
        reset();
        File_name = undefined;//画像登録用20230411追記
        damageReset();
        createModalClose();
        deleteLatLng();
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/vermin-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
        // ↓ 20240416 Add Uduki 続けてレポートを登録する
        if(cookie?.verminData?.user_kind_id === 3){
          var result = window.confirm('続けて報告書の情報を登録しますか？');
          if(result){
            open_report_modal(1, Number(res?.data?.new_id));
          }
        }
        // ↑ 20240416 Add Uduki 続けてレポートを登録する
      }).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors);
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
    }
  }

  const registerDamage = (data: DamageFormValues) => {
    setLoading(true);
    //情報編集時のAPI
    if (damageData) {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/update-damage`, {
        id: damageData?.damage_id,
        damage_type: data.damage_type,
        vermin_kind: data.vermin_kind,
        discovery_date: dayjs(data.discovery_date).format('YYYY/MM/DD'),
        discovery_time: dayjs(data.discovery_time).format('HH:mm'),
        contents: data.contents,
        implementation: data.implementation,
        countermeasures: data.countermeasures,
        implementation_date: data.implementation_date ? dayjs(data.implementation_date).format('YYYY/MM/DD') : undefined,
        implementation_time: data.implementation_time ? dayjs(data.implementation_time).format('HH:mm') : undefined,
        latitude: data.latitude,
        longitude: data.longitude,
        remarks: data.remarks,
        displayability: data.displayability,
        delete: damageWatch("delete") === "delete" ? '[]' : null,
        delete_id: damageWatch("delete") === "delete" ? damageData?.damage_id : null,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then(async (res) => {
        const d_id = damageData?.damage_id;
        const delete_check = damageWatch("delete") === "delete"
        setErrors(res?.data?.errors);
        deleteEditDamageData();
        damageReset();
        reset();
        createDamageModalClose();
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/damage-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
        // ↓ 20240416 Add Uduki 続けてレポートを登録する
        if(cookie?.verminData?.user_kind_id === 3 && !delete_check){
          var result = window.confirm('続けて報告書の情報を登録しますか？');
          if(result){
            open_report_modal(2, d_id);
          }
        }
        // ↑ 20240416 Add Uduki 続けてレポートを登録する
      }
      ).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
      //情報登録時のAPI
    } else {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/register-damage`, {
        damage_type: data.damage_type,
        vermin_kind: data.vermin_kind,
        discovery_date: dayjs(data.discovery_date).format('YYYY/MM/DD'),
        discovery_time: dayjs(data.discovery_time).format('HH:mm'),
        contents: data.contents,
        implementation: data.implementation,
        countermeasures: data.countermeasures,
        implementation_date: data.implementation_date ? dayjs(data.implementation_date).format('YYYY/MM/DD') : null,
        implementation_time: data.implementation_time ? dayjs(data.implementation_time).format('HH:mm') : null,
        latitude: data.latitude,
        longitude: data.longitude,
        remarks: data.remarks,
        displayability: data.displayability,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then(async (res) => {
        setErrors(res?.data?.errors);
        deleteEditDamageData();
        damageReset();
        reset();
        createDamageModalClose();
        deleteLatLng();
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/damage-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
        // ↓ 20240416 Add Uduki 続けてレポートを登録する
        if(cookie?.verminData?.user_kind_id === 3){
          var result = window.confirm('続けて報告書の情報を登録しますか？');
          if(result){
            open_report_modal(2, Number(res?.data?.new_id));
          }
        }
        // ↑ 20240416 Add Uduki 続けてレポートを登録する
      }).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      }
      );
    }
  }

  const registerTrap = (data: TrapFormValues) => {
    setLoading(true);
    //情報編集時のAPI
    if (trapData) {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/update-trap`, {
        id: trapData?.trap_id,
        vermin_kind: data.vermin_kind,
        trap_hunting: data.trap_hunting,
        trap_start: data.trap_start ? dayjs(data.trap_start).format('YYYY/MM/DD') : undefined,
        trap_stop: data.trap_stop ? dayjs(data.trap_stop).format('YYYY/MM/DD') : undefined,
        latitude: data.latitude,
        longitude: data.longitude,
        address: data.address,
        log_lat: data.log_lat,
        log_lon: data.log_lon,
        count: data.count,
        admin: data.admin,
        admin_tel: data.admin_tel,
        result: data.result,
        mistake: trapWatch("mistake") === "mistake" ? '[]' : null,
        mistake_log: data.mistake_log,
        camera_id: data.camera_id,
        remarks: data.remarks,
        displayability: data.displayability,
        delete: trapWatch("delete") === "delete" ? '[]' : null,
        delete_id: trapWatch("delete") === "delete" ? trapData?.trap_id : null,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then(async (res) => {
        setErrors(res?.data?.errors);
        deleteEditTrapData();
        trapReset();
        reset();
        createTrapModalClose();
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/trap-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
      }
      ).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
      //情報登録時のAPI
    } else {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/register-trap`, {
        vermin_kind: data.vermin_kind,
        trap_hunting: data.trap_hunting,
        trap_start: data.trap_start ? dayjs(data.trap_start).format('YYYY/MM/DD') : undefined,
        trap_stop: data.trap_stop ? dayjs(data.trap_stop).format('YYYY/MM/DD') : undefined,
        latitude: data.latitude,
        longitude: data.longitude,
        address: data.address,
        log_lat: data.log_lat,
        log_lon: data.log_lon,
        count: data.count,
        admin: data.admin,
        admin_tel: data.admin_tel,
        result: data.result,
        mistake: trapWatch("mistake") === "mistake" ? '[]' : null,
        mistake_log: data.mistake_log,
        camera_id: data.camera_id,
        remarks: data.remarks,
        displayability: data.displayability,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then(async (res) => {
        setErrors(res?.data?.errors);
        deleteEditTrapData();
        trapReset();
        reset();
        createTrapModalClose();
        deleteLatLng();
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/trap-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
      }).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      }
      );
    }
  }

  const registerCamera = (data: CameraFormValues) => {
    setLoading(true);
    //情報編集時のAPI
    if (cameraData) {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/update-camera`, {
        id: cameraData?.camera_id,
        camera_start: data.camera_start ? dayjs(data.camera_start).format('YYYY/MM/DD') : undefined,
        camera_stop: data.camera_stop ? dayjs(data.camera_stop).format('YYYY/MM/DD') : undefined,
        latitude: data.latitude,
        longitude: data.longitude,
        direction: data.direction,
        trap_id: data.trap_id,
        remarks: data.remarks,
        displayability: data.displayability,
        delete: cameraWatch("delete") === "delete" ? '[]' : null,
        delete_id: cameraWatch("delete") === "delete" ? cameraData?.camera_id : null,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then(async (res) => {
        setErrors(res?.data?.errors);
        deleteEditCameraData();
        cameraReset();
        reset();
        createCameraModalClose();
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/camera-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
      }
      ).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
      //情報登録時のAPI
    } else {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/register-camera`, {
        camera_start: data.camera_start ? dayjs(data.camera_start).format('YYYY/MM/DD') : undefined,
        camera_stop: data.camera_stop ? dayjs(data.camera_stop).format('YYYY/MM/DD') : undefined,
        latitude: data.latitude,
        longitude: data.longitude,
        direction: data.direction,
        trap_id: data.trap_id,
        remarks: data.remarks,
        displayability: data.displayability
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then(async (res) => {
        setErrors(res?.data?.errors);
        deleteEditCameraData();
        cameraReset();
        reset();
        createCameraModalClose();
        deleteLatLng();
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/camera-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
      }).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      }
      );
    }
  }
  //防止施設用20230413
  const registerPrev = (data: PrevFormValues) => {
    setLoading(true);
    //Line情報をText情報に変換
    let Line_Text = "None";
    if(Line){
      Line_Text = "";
      for (const lin of Line) {
        Line_Text = Line_Text + "A"+lin.lng+" "+lin.lat+"A";
      }
      Line_Text = Line_Text.replaceAll("AA",", ");
      Line_Text = Line_Text.replaceAll("A","");
    }
    //情報編集時のAPI
    if (data.id) {
      console.log(Line_Text);//Test用
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/update-prev`, {
        id: data.id,
        type_name: data.type_name,
        delivery_year: data.delivery_year,
        delivery_date: data.delivery_date ? dayjs(data.delivery_date).format('YYYY/MM/DD') : undefined,
        admin: data.admin,
        admin_tel: data.admin_tel,
        adress: data.adress,
        distance: data.distance,
        geom_text: Line_Text,
        remarks: data.remarks,
        displayability: data.displayability,
        delete: prevWatch("delete") === "delete" ? '[]' : null,
        delete_id: prevWatch("delete") === "delete" ? prevData?.prev_faci_id : null,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then(async (res) => {
        setErrors(res?.data?.errors);
        deleteEditPrevData();
        prevReset();
        reset();
        createPrevModalClose();
        deleteLine();
        setVermins([]);
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/prev-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
      }
      ).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
      //情報登録時のAPI
    } else {
      if(Line_Text == "None"){
        if(Line_Error){
          Line_Error.innerHTML = "防止施設位置情報は必須入力です";
        }
        setLoading(false);
        return
      }
      setLoading(false);
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/register-prev`, {
        type_name: data.type_name,
        delivery_year: data.delivery_year,
        delivery_date: data.delivery_date ? dayjs(data.delivery_date).format('YYYY/MM/DD') : undefined,
        admin: data.admin,
        admin_tel: data.admin_tel,
        adress: data.adress,
        distance: data.distance,
        geom_text: Line_Text,
        remarks: data.remarks,
        displayability: data.displayability
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then(async (res) => {
        setErrors(res?.data?.errors);
        deleteEditPrevData();
        prevReset();
        reset();
        createPrevModalClose();
        deleteLine();
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/prev-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
      }).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      }
      );
    }
  }

  const registerIndpin = (data: IndpinFormValues) => {
    setLoading(true);
    //情報編集時のAPI
    if (indpinData) {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/update-indpin`, {
        id: indpinData?.indpin_id,
        label: data.label,
        latitude: data.latitude,
        longitude: data.longitude,
        comment: data.comment,// 20250417 Add Uduki
        displayability: data.displayability,
        delete: indpinWatch("delete") === "delete" ? '[]' : null,
        delete_id: indpinWatch("delete") === "delete" ? indpinData?.indpin_id : null,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then(async (res) => {
        setErrors(res?.data?.errors);
        deleteEditIndpinData();
        indpinReset();
        reset();
        createIndpinModalClose();
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/indpin-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
      }
      ).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
      //情報登録時のAPI
    } else {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/register-indpin`, {
        label: data.label,
        latitude: data.latitude,
        longitude: data.longitude,
        comment: data.comment,// 20250417 Add Uduki
        displayability: data.displayability,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then(async (res) => {
        setErrors(res?.data?.errors);
        deleteEditIndpinData();
        indpinReset();
        reset();
        createIndpinModalClose();
        deleteLatLng();
        await mutate([`${process.env.REACT_APP_DEV_API_URL}/indpin-marker`, {
          headers: {
            Authorization: `Bearer ${cookie?.verminData?.api_token}`
          }
        }])
        await setLoading(false);
        //refetchの代わり
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }//230420追記
      }).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      }
      );
    }
  }

  /**
   * 報告書「保存/PDF出力」押下時の処理
   * @param data 入力レポートデータ
   * 20240411 Add Uduki
   */
  const registerReport = (data: ReportFormValues) => {
    setLoading(true);
    //情報編集時のAPI
    console.log(data);
    axios.post(`${process.env.REACT_APP_DEV_API_URL}/update-report`, {
      report_kind: data.report_kind,
      information_id: data.information_id,
      receptionist_nm: data.receptionist_nm,
      vermin_kind: data.vermin_kind_id,
      ecology: data.ecology,
      latitude: data.latitude,
      longitude: data.longitude,
      reporter_nm: data.reporter_nm,
      waypoint: data.waypoint,
      report_nm: data.report_nm,
      report_tel: data.report_tel,
      administrative_district: data.administrative_district,
      report_st: data.report_st,
      confirmer: data.confirmer,
      witness: data.witness,
      witness_tel: data.witness_tel,
      zoning: data.zoning,
      zoning_st: data.zoning_st,
      contact_rp: data.contact_rp,
      count: data.head_count,
      discovery_address: data.discovery_address,
      hdamage_nt: data.hdamage_nt,
      crop_nm: data.crop_nm,
      crop_ps: data.new_crop_ps,
      crop_co: data.crop_co,
      crop_ar: data.crop_ar,
      crop_nt: data.crop_nt,
      digging_up_dp: data.digging_up_dp,
      digging_up_nt: data.digging_up_nt,
      damage_other: data.damage_other,
      remarks: data.remarks,
      report_dt: data.report_dt ? dayjs(data.report_dt).format('YYYY/MM/DD') : undefined,
      discovery_dt: data.discovery_dt ? dayjs(data.discovery_dt).format('YYYY/MM/DD') : undefined,
      discovery_tm: dayjs(data.discovery_tm).format('HH:mm'),
      receptionist_dt: data.receptionist_dt ? dayjs(data.receptionist_dt).format('YYYY/MM/DD') : undefined,
      receptionist_tm: dayjs(data.receptionist_tm).format('HH:mm'),
      confirmation_dt: data.confirmation_dt ? dayjs(data.confirmation_dt).format('YYYY/MM/DD') : undefined,
      confirmation_tm: dayjs(data.confirmation_tm).format('HH:mm'),
      attachKind: data.new_attachKind,
      attach_other_r: data.attach_other_r,
      }, {
        headers: {
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
        }
      }).then(async (res) => {
        setErrors(res?.data?.errors);
        deleteEditReportData();
        reportReset();
        reset();
        createReportModalClose();
        deleteLatLng();
        if (searchCondition) {
          search(searchCondition);
        }else if (searchCheck) {
          mapsearch(searchCheck);
        }
        setLoading(false);
        var result = window.confirm('続けて報告書のPDFをダウンロードいたしますか？');
        if(result){
          download_report(data.report_kind,data.information_id,res?.data?.client_seq)
        }
      }
      ).catch(async (err) => {
        setLoading(false);
        setErrors(err?.response?.data?.errors)
        //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
        if (err?.response?.data?.message === "Unauthenticated.") {
          await setVermins([]);
          await setIds([]);
          await setProc("");
          await cookies.remove('verminData');
          await window.location.replace('/');
        }
      });
  }

  /**
   * 報告書のPDFをダウンロードする処理
   * @param report_kind レポートの種別(1:害獣、2:被害)
   * @param information_id PDF出力する害獣(or 被害)情報のID
   * 20240411 Add Uduki
   */
  const download_report = (par_report_kind: number,par_information_id: number,client_seq :number) => {
    setLoading(true);
    axios.post(`${process.env.REACT_APP_DEV_API_URL}/pdf/export/report_data`, {
      report_kind:par_report_kind,
      information_id:par_information_id,
    },{
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${cookie?.verminData?.api_token}`
      }
      //文字化け対策のバイナリデータ修正
    }).then((res) => {
      const file_name = '有害鳥獣出没現地確認報告書_No.'+String(client_seq)+'_'+dayjs().format('YYYYMMDD_HHmmss')+'.pdf';
      fileDownload(res.data, file_name)
    }).catch(async (err) => {
      //認証切れの場合、Cookie保持データを削除してTOP画面に戻す
      if (err?.response?.data?.message === "Unauthenticated.") {
        await cookies.remove('verminData');
        await window.location.replace('/');
      }
    }).finally(() => {
      setLoading(false);
    });
  }

  /**
   * 報告書の登録画面表示
   * @param report_kind レポートの種別(1:害獣、2:被害)
   * @param information_id PDF出力する害獣(or 被害)情報のID
   * 20240411 Add Uduki
   */
    const open_report_modal = (par_report_kind: number,par_information_id: number) => {
      axios.post(`${process.env.REACT_APP_DEV_API_URL}/report_data`, {
        report_kind:par_report_kind,
        information_id:par_information_id,
      },{
        headers: { 
          Authorization: `Bearer ${cookie?.verminData?.api_token}`
         }}).then((res) => {
          if(res.data.features){
            setEditReportData(res.data.features);
            createReportModalOpen();
          }
        }).catch(async (err) => {
          console.log('axios Error')
        })
    }

  /**
   * 捕獲方法の表示非表示を制御するハンドラ
   */
  const trap_display = (value: string) => {
    document.getElementById("shoot")!.style.display = "none";
    document.getElementById("t_d_n")!.style.display = "none";
    document.getElementById("t_d_i")!.style.display = "none";
    document.getElementById("c_d_n")!.style.display = "none";
    if(value == "捕獲" || value == "錯誤捕獲"){
      document.getElementById("t_d_n")!.style.display = "block";
      document.getElementById("t_d_i")!.style.display = "block";
    }else if(value == "狩猟"){
      document.getElementById("t_d_n")!.style.display = "block";
      document.getElementById("shoot")!.style.display = "block";
      document.getElementById("t_d_i")!.style.display = "block";
    }else if(value == "観察"){
      document.getElementById("c_d_n")!.style.display = "block";
    }
  };
  /**
   * 情報分類変更時に実行するハンドラ
   * @example
   * <Select {onChange={trap_input}}>...</Button>
   */
  const trap_input = useCallback((ev: React.ChangeEvent<HTMLSelectElement>) => {
    const value = ev.target.value;
    trap_display(value);
  }, []);

  /**
   * 報告書　添付資料その他詳細表示非表示制御
   * @example
   * <Select {onChange={attach_other}}>...</Button>
   * 20240411 Add Uduki 
   */
  const attach_other_change = useCallback((ev: React.ChangeEvent<HTMLInputElement>) => {
    const value = ev.target.checked;
    if (value) {
      document.getElementById("attach_other")!.style.display = "block";
    } else {
      document.getElementById("attach_other")!.style.display = "none";
    }
  }, []);

  /**
   * サイドバーを開くハンドラ
   * @example
   * <Button onClick={handleSidebarToggle}>...</Button>
   */
  const handleSidebarToggle = () => {
    setSidebarVisible(!sidebarVisible)
    dropClose();
  }

  const UserIndex = () => {
    let LTI = cookie.verminData.api_token;
    if(LTI){
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/user/index?token="+LTI;
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }else{
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/user/index?token=";
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }
  }
  const PassChange = () => {
    let LTI = cookie.verminData.api_token;
    if(LTI){
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/user/change/edit?token="+LTI;
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }else{
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/user/change/edit?token=";
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }
  }
  const PassReset = () => {
    window.open(`${process.env.REACT_APP_DEV_URL}`+"/user/reset", '_blank', "resizable,scrollbars,status");
  }
  const ClientEdit = () => {
    let LTI = cookie.verminData.api_token;
    if(LTI){
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/client/edit?token="+LTI;
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }else{
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/client/edit?token=";
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }
  }
  const NewClientEdit = () => {
    let LTI = cookie.verminData.api_token;
    if(LTI){
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/client/index?token="+LTI+"&id=newclient";
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }else{
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/client/index?token="+LTI;
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }
  }
  const DisResIndex = () => {
    let LTI = cookie.verminData.api_token;
    if(LTI){
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/disres/disindex?token="+LTI;
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }else{
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/disres/disindex?token=";
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }
  }
  const TempIndex = () => {
    let LTI = cookie.verminData.api_token;
    if(LTI){
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/temp/index?token="+LTI;
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }else{
      let URL = `${process.env.REACT_APP_DEV_URL}`+"/temp/index?token=";
      window.open(URL, '_blank', "resizable,scrollbars,status");
    }
  }
  /**
 * サイドバーを閉じるハンドラ
 * @example
 * <Button onClick={handleSidebarToggle}>...</Button>
 */
  const handleSidebarClose = () => {
    setSidebarVisible(false);
    //ログイン後のログインフォームに値が残ってしまうのを防ぐため
    loginReset()
    setLoginError('');
  }

  return (
    <>
      <div className={styles.wrapper}>
        {/**
          * ↓↓↓ 「害獣情報新規登録・修正」モーダル ↓↓↓
          * データを持っているとき、編集時のボタンや文面に変更する
          */}
        <Modal
          label={verminData ? "害獣情報編集" : "害獣情報新規登録"}
          onClick={handleRegistrationModalToggle}
          open={isCreateModal}
          variant="wide"
        >
          <Form onSubmit={handleSubmit(registerVermin)}>
            <Field label="害獣種別" required={true} className={styles.field}>
              <Select variant="middle" {...register("vermin_kind", { required: true })}>
                <option value="" hidden>害獣種別をご選択ください</option>
                {Object.entries(vermin_category).map((value) => {
                  return(<option value={value[0]}>{value[1]}</option>);})}
              </Select>
              {errors?.vermin_kind?.length !== 0 && errors?.vermin_kind?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
              {verminErrors?.vermin_kind?.type === "required" && <p className={styles.modalErrorText}>害獣種別は必須入力です</p>}
            </Field>
            <Field label="情報分類" required={true} className={styles.field}>
              <Select variant="middle"
              {...register('vermin_ecology', { required: true, validate: value => value === "目撃" || value === "足跡" || value === "糞便" || value === "食痕" 
              || value === "掘り起こし" || value === "錯誤捕獲" || value === "テレメトリー" || value === "捕獲" ||  value === "狩猟" || value === "錯誤捕獲" || value === "観察" })}
              onChange={trap_input}>
                <option value="" hidden>情報分類をご選択ください</option>
                <option value="捕獲">捕獲</option>
                <option value="観察">観察</option>
                <option value="狩猟">狩猟</option>
                <option value="目撃">目撃</option>
                <option value="足跡">足跡</option>
                <option value="糞便">糞便</option>
                <option value="食痕">食痕</option>
                <option value="掘り起こし">掘り起こし</option>
                <option value="テレメトリー">テレメトリー</option>
                <option value="錯誤捕獲">錯誤捕獲</option>
              </Select>
              {verminErrors?.vermin_ecology?.type === "validate" && <p className={styles.modalErrorText}>情報分類に選択肢以外の回答が入力されています。</p>}
              {verminErrors?.vermin_ecology?.type === "required" && <p className={styles.modalErrorText}>情報分類は必須入力です</p>}
            </Field>
            <Field label="目撃年月日" className={styles.field}>
              <Controller control={control}
                name='discovery_date' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja} showMonthDropdown={true} showYearDropdown={true}//230419追加
                    className={clsx(styles.input, styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )} />
              {errors?.discovery_date?.length !== 0 && errors?.discovery_date?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>
            <Field label="目撃時刻" className={styles.field}>
              <Controller control={control}
                name='discovery_time' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="HH:mm"
                    showTimeSelect showTimeSelectOnly timeCaption="Time"
                    locale={ja}
                    className={clsx(styles.input, styles.width_limit)} placeholderText='00:00' selected={value as unknown as Date} />
                )} />
              {errors?.discovery_time?.length !== 0 && errors?.discovery_time?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>
            <Field label="緯度" required={true} className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...register("lat", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 90) && (value >= -90) })}
              />
              {verminErrors?.lat?.type === "required" && <p className={styles.modalErrorText}>緯度は必須入力です</p>}
              {verminErrors?.lat?.type === "pattern" && <p className={styles.modalErrorText}>緯度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {verminErrors?.lat?.type === "validate" && <p className={styles.modalErrorText}>緯度は-90以上90以下の値を入力して下さい。</p>}
            </Field>
            <Field label="経度" required={true} className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...register("lng", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 180) && (value >= -180) })}
              />
              {verminErrors?.lng?.type === "required" && <p className={styles.modalErrorText}>経度は必須入力です</p>}
              {verminErrors?.lng?.type === "pattern" && <p className={styles.modalErrorText}>経度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {verminErrors?.lng?.type === "validate" && <p className={styles.modalErrorText}>経度は-180以上180以下の値を入力して下さい。</p>}
            </Field>
            <Field label="所在" className={styles.field}>
              <Input
                type="text"
                placeholder="例）●●●町付近"
                variant="full"
                {...register("address")}
              />
            </Field>
            <Field label="頭数" /*required={true}*/ >
              <div className={styles.fieldRow}>
                <Input
                  type="text"
                  placeholder="頭数をご記入ください(不明時は未記入)"
                  variant="middle"
                  {...register("count", { /*required: true,*/ pattern: /^[0-9]{1,}$/ })} />
                <p className={styles.labelText}>
                  頭
                </p>
              </div>
              {/*{verminErrors?.count?.type === "required" && <p className={styles.modalErrorText}>頭数は必須入力です。</p>}*/}
              {verminErrors?.count?.type === "pattern" && <p className={styles.modalErrorText}>頭数は半角数字で入力してください。</p>}
            </Field>
            <Field label="群れ" className={styles.field}>
            <Input
                type="text"
                placeholder="群れの情報を入力"
                variant="full"
                className={styles.width_limit}
                {...register("herd")}
              />
            </Field>
            <Field label="捕獲方法" className={styles.field} id="t_d_n">
              <Select variant="middle"  {...register("trap_hunting")}>
                <option value="" hidden>捕獲方法をご選択ください</option>
                {Object.entries(trapDisplayOrder).map((val,key) => {
                  const label = trapList[Number(val[1])];
                  if (val[1] == "5") {
                    return(<option id="shoot" value={label}>{label}</option>);
                  } else {
                    return(<option value={label}>{label}</option>);
                  }})}
              </Select>
            </Field>
            <Field label="捕獲罠ID" className={styles.field} id="t_d_i">
              <Input
                type="text"
                placeholder="捕獲罠IDをご記入ください"
                variant="full"
                className={styles.width_limit}
                {...register("trap_id",{ pattern: /^[0-9]{1,}$/ })}
              />
              {verminErrors?.trap_id?.type === "pattern" && <p className={styles.modalErrorText}>罠IDは半角数字で入力してください。</p>}
            </Field>
            <Field label="撮影カメラID" className={styles.field} id="c_d_n">
              <Input
                type="text"
                placeholder="撮影カメラIDをご記入ください"
                variant="full"
                className={styles.width_limit}
                {...register("camera_id",{ pattern: /^[0-9]{1,}$/ })}
              />
              {verminErrors?.camera_id?.type === "pattern" && <p className={styles.modalErrorText}>罠IDは半角数字で入力してください。</p>}
            </Field>
            {/*画像登録用20230411追記*/}
            {/*(cookie?.verminData?.client_authority%2 === 0) &&*/
            <Field label="害獣撮影画像(png,jpg,jpeg限定)(1枚まで)" className={styles.field}>
              <p>{File_name && `・${File_name}`}</p>
              {!File_name && <div {...getRootProps()} className={styles.drop_area}>
                <input {...getInputProps} />
                <p>ファイルを選択または<br />
                ドラッグアンドドロップ</p>
              </div>}
              {File_name && <img style={{marginTop:"5px",maxHeight:"100px",maxWidth:"100px"}} src={profileImage} />}
              <div style={{marginTop: "5px"}}>
              <Button onClick={picture_delate} disabled={File_name==null}>
                画像削除
              </Button>
              </div>
            </Field>}
            <Field label="公開範囲" required={true} className={styles.field}>
              <Select variant="middle" className={clsx(watch("displayability") === "" && styles.initialValueText)} {...register("displayability", { required: true, validate: value => value === "公開" || value === "ログイン閲覧者公開" || value === "登録修正論理削除権限者公開" || value === "管理者公開" })} disabled={cookie?.verminData?.user_kind_id !== 3}>
                <option value="" hidden>公開範囲をご選択ください</option>
                <option value="公開">公開</option>
                <option value="ログイン閲覧者公開">ログイン閲覧者公開</option>
                <option value="登録修正論理削除権限者公開">登録修正論理削除権限者公開</option>
                <option value="管理者公開">管理者公開</option>
              </Select>
              {verminErrors?.displayability?.type === "required" && <p className={styles.modalErrorText}>公開範囲は必須入力です。</p>}
              {verminErrors?.displayability?.type === "validate" && <p className={styles.modalErrorText}>公開範囲に選択肢以外の回答が入力されています。</p>}
            </Field>
            {verminData &&
            <Field label="削除" className={styles.field}>
              <Radio type="checkbox" value="delete" {...register("delete")} className={styles.defaultRadius} />
            </Field>
            }
            <Field label="備考" className={styles.field}>
              <Textarea
                rows={3}
                placeholder="備考情報を入力"
                {...register("remarks")}
              />
            </Field>
            <ButtonsWrap>
              <Button type="button" variant="cancel" onClick={handleRegistrationModalToggle}>
                キャンセル
              </Button>
              <Button type="submit">
                登録
              </Button>
            </ButtonsWrap>
          </Form>
        </Modal>

        {/* 被害情報登録モーダル */}
        <Modal
          label={verminData ? "被害情報編集" : "被害情報新規登録"}
          onClick={handleCreateDamageModalClose}
          open={isCreateDamageModal}
          variant="wide"
        >
          <Form onSubmit={damageSubmit(registerDamage)}>
            <Field label="被害物種別" required={true} className={styles.field}>
              <Select variant="middle" className={clsx(damageWatch("damage_type") === "" && styles.initialValueText)} {...damageRegister("damage_type", { required: true, validate: (value) => value === "防止施設" || value === "農産物" || value === "人" || value === "生活環境" })}>
                <option value="" hidden>被害物をご選択ください</option>
                <option value="防止施設">防止施設</option>
                <option value="農産物">農産物</option>
                <option value="人">人</option>
                <option value="生活環境">生活環境</option>{/*230707コメアウト*/}
              </Select>
              {damageErrors?.damage_type?.type === "validate" && <p className={styles.modalErrorText}>被害物種別に選択肢以外の回答が入力されています。</p>}
              {damageErrors?.damage_type?.type === "required" && <p className={styles.modalErrorText}>被害物種別は必須入力です</p>}
            </Field>
            <Field label="被害内容" className={styles.field}>
              <Textarea
                rows={3}
                placeholder="被害内容ををご記入ください"
                {...damageRegister("contents")}
              />
            </Field>
            <Field label="害獣種別" required={true} className={styles.field}>
              <Select variant="middle" className={clsx(damageWatch("vermin_kind") === "" && styles.initialValueText)}
                {...damageRegister("vermin_kind", { required: true, validate: (value) => vermin_category.hasOwnProperty(value)})}>
                  <option value={undefined} hidden>害獣種別をご選択ください</option>
                  {Object.entries(vermin_category).map((value) => {
                    return(<option value={value[0]}>{value[1]}</option>);})}
              </Select>
              {damageErrors?.vermin_kind?.type === "validate" && <p className={styles.modalErrorText}>害獣種別に選択肢以外の回答が入力されています。</p>}
              {damageErrors?.vermin_kind?.type === "required" && <p className={styles.modalErrorText}>害獣種別は必須入力です</p>}
            </Field>
            <Field label="被害発生日" className={styles.field}>
              <Controller control={damageControl}
                name='discovery_date' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja} showMonthDropdown={true} showYearDropdown={true}//230419追加
                    className={clsx(styles.input,styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )} />
              {errors?.discovery_date?.length !== 0 && errors?.discovery_date?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>
            <Field label="被害発生時刻" className={styles.field}>
              <Controller control={damageControl}
                name='discovery_time' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="HH:mm"
                    showTimeSelect showTimeSelectOnly timeCaption="Time"
                    locale={ja}
                    className={clsx(styles.input,styles.width_limit)} placeholderText='00:00' selected={value as unknown as Date} />
                )} />
              {errors?.discovery_time?.length !== 0 && errors?.discovery_time?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>
            <Field label="緯度" required={true} className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...damageRegister("latitude", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 90) && (value >= -90) })}
              />
              {damageErrors?.latitude?.type === "required" && <p className={styles.modalErrorText}>緯度は必須入力です</p>}
              {damageErrors?.latitude?.type === "pattern" && <p className={styles.modalErrorText}>緯度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {damageErrors?.latitude?.type === "validate" && <p className={styles.modalErrorText}>緯度は-90以上90以下の値を入力して下さい。</p>}
            </Field>
            <Field label="経度" required={true} className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...damageRegister("longitude", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 180) && (value >= -180) })}
              />
              {damageErrors?.longitude?.type === "required" && <p className={styles.modalErrorText}>経度は必須入力です</p>}
              {damageErrors?.longitude?.type === "pattern" && <p className={styles.modalErrorText}>経度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {damageErrors?.longitude?.type === "validate" && <p className={styles.modalErrorText}>経度は-180以上180以下の値を入力して下さい。</p>}
            </Field>
            <Field label="対策実施状況" required={true} className={styles.field}>
              <Select variant="middle" className={clsx(damageWatch("implementation") === "" && styles.initialValueText)} {...damageRegister('implementation', { required: true, validate: (value) => value === "対策検討中" || value === "対策準備中" || value === "対策実施完了" || value === "対策必要なし" })}>
                <option value="" hidden>対策実施状況をご選択ください</option>
                <option value="対策検討中">対策検討中</option>
                <option value="対策準備中">対策準備中</option>
                <option value="対策実施完了">対策実施完了</option>
                <option value="対策必要なし">対策必要なし</option>
              </Select>
              {damageErrors?.implementation?.type === "required" && <p className={styles.modalErrorText}>対策実施状況は必須入力です</p>}
              {damageErrors?.implementation?.type === "validate" && <p className={styles.modalErrorText}>対策実施状況に選択肢以外の回答が入力されています。</p>}
            </Field>
            <Field label="対策実施内容" className={styles.field}>
              <Input
                type="text"
                placeholder="どの様な対策を行うかご記入ください"
                variant="full"
                {...damageRegister("countermeasures")}
                disabled={damageWatch("implementation") === "対策必要なし"}
              />
            </Field>
            <Field label="対策実施日" className={styles.field}>
              <Controller control={damageControl}
                name='implementation_date' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja} showMonthDropdown={true} showYearDropdown={true}//230419追加
                    disabled={damageWatch("implementation") === "対策必要なし"}
                    className={clsx(styles.input,styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )} />
              {errors?.implementation_date?.length !== 0 && errors?.implementation_date?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>
            <Field label="対策実施時刻" className={styles.field}>
              <Controller control={damageControl}
                name='implementation_time' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="HH:mm"
                    disabled={damageWatch("implementation") === "対策必要なし"}
                    showTimeSelect showTimeSelectOnly timeCaption="Time"
                    locale={ja}
                    className={clsx(styles.input,styles.width_limit)} placeholderText='00:00' selected={value as unknown as Date} />
                )} />
              {errors?.implementation_time?.length !== 0 && errors?.implementation_time?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>
            <Field label="公開範囲" required={true} className={styles.field}>
              <Select variant="middle" className={clsx(damageWatch("displayability") === "" && styles.initialValueText)} {...damageRegister("displayability", { required: true, validate: value => value === "公開" || value === "ログイン閲覧者公開" || value === "登録修正論理削除権限者公開" || value === "管理者公開" })} disabled={cookie?.verminData?.user_kind_id !== 3}>
                <option value="" hidden>公開範囲をご選択ください</option>
                <option value="公開">公開</option>
                <option value="ログイン閲覧者公開">ログイン閲覧者公開</option>
                <option value="登録修正論理削除権限者公開">登録修正論理削除権限者公開</option>
                <option value="管理者公開">管理者公開</option>
              </Select>
              {damageErrors?.displayability?.type === "required" && <p className={styles.modalErrorText}>公開範囲は必須入力です</p>}
              {damageErrors?.displayability?.type === "validate" && <p className={styles.modalErrorText}>公開範囲に選択肢以外の回答が入力されています。</p>}
            </Field>
            {damageData &&
              <Field label="削除" className={styles.field}>
                <Radio type="checkbox" value="delete" {...damageRegister("delete")} />
              </Field>
            }
            <Field label="備考" className={styles.field}>
              <Textarea
                rows={3}
                placeholder="備考情報を入力"
                {...damageRegister("remarks")}
              />
            </Field>
            <ButtonsWrap>
              <Button type="button" variant="cancel" onClick={handleCreateDamageModalClose}>
                キャンセル
              </Button>
              <Button type="submit">
                登録
              </Button>
            </ButtonsWrap>
          </Form>
        </Modal>
        {/* 罠情報登録モーダル */}
        <Modal
          label={verminData ? "罠情報編集" : "罠情報新規登録"}
          onClick={handleCreateTrapModalClose}
          open={isCreateTrapModal}
          variant="wide"
        >
          <Form onSubmit={trapSubmit(registerTrap)}>
            <Field label="罠種別" required={true} className={styles.field}>
              <Select variant="middle" {...trapRegister("trap_hunting", { required: true })}>
                <option value="" hidden>罠種別をご選択ください</option>
                {Object.entries(trapList).filter((value) => (Number(value[0]) < 5)).map((value) => {
                    return(<option value={value[0]}>{value[1]}</option>);})}
              </Select>
              {trapErrors?.trap_hunting?.type === "validate" && <p className={styles.modalErrorText}>罠種別に選択肢以外の回答が入力されています。</p>}
              {trapErrors?.trap_hunting?.type === "required" && <p className={styles.modalErrorText}>罠種別は必須入力です</p>}
            </Field>
            <Field label="対象害獣種別" required={true} className={styles.field}>
              <Select variant="middle" {...trapRegister("vermin_kind", { required: true, validate: (value) => vermin_category.hasOwnProperty(value)})}>
                  <option value={undefined} hidden>対象害獣種別をご選択ください</option>
                  {Object.entries(vermin_category).map((value) => {
                    return(<option value={value[0]}>{value[1]}</option>);})}
              </Select>
              {trapErrors?.vermin_kind?.type === "validate" && <p className={styles.modalErrorText}>対象害獣種別に選択肢以外の回答が入力されています。</p>}
              {trapErrors?.vermin_kind?.type === "required" && <p className={styles.modalErrorText}>対象害獣種別は必須入力です</p>}
            </Field>
            <Field label="罠設置日" className={styles.field}>
              <Controller control={trapControl}
                name='trap_start' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja} showMonthDropdown={true} showYearDropdown={true}//230419追加
                    className={clsx(styles.input,styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )} />
            </Field>
            <Field label="罠回収日" className={styles.field}>
              <Controller control={trapControl}
                name='trap_stop' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja} showMonthDropdown={true} showYearDropdown={true}//230419追加
                    className={clsx(styles.input,styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )} />
            </Field>
            <Field label="捕獲結果" className={styles.field}>
              <Textarea
                rows={3}
                placeholder="捕獲結果ををご記入ください"
                {...trapRegister("result")}
              />
            </Field>
            <Field label="緯度" required={true} className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...trapRegister("latitude", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 90) && (value >= -90) })}
              />
              {trapErrors?.latitude?.type === "required" && <p className={styles.modalErrorText}>緯度は必須入力です</p>}
              {trapErrors?.latitude?.type === "pattern" && <p className={styles.modalErrorText}>緯度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {trapErrors?.latitude?.type === "validate" && <p className={styles.modalErrorText}>緯度は-90以上90以下の値を入力して下さい。</p>}
            </Field>
            <Field label="経度" required={true} className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...trapRegister("longitude", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 180) && (value >= -180) })}
              />
              {trapErrors?.longitude?.type === "required" && <p className={styles.modalErrorText}>経度は必須入力です</p>}
              {trapErrors?.longitude?.type === "pattern" && <p className={styles.modalErrorText}>経度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {trapErrors?.longitude?.type === "validate" && <p className={styles.modalErrorText}>経度は-180以上180以下の値を入力して下さい。</p>}
            </Field>
            <Field label="所在" className={styles.field}>
              <Input
                type="text"
                placeholder="例）●●●町付近"
                variant="full"
                {...trapRegister("address")}
              />
            </Field>
            <Field label="設置個数" required={true} >
              <div className={styles.fieldRow}>
                <Input
                  type="text"
                  placeholder="設置した罠の個数を入力ください"
                  variant="middle"
                  defaultValue="1" //20250723 Upd Uduki
                  {...trapRegister("count", { required: true, pattern: /^[0-9]{1,}$/ })} />
                <p className={styles.labelText}>
                  個
                </p>
              </div>
              {trapErrors?.count?.type === "required" && <p className={styles.modalErrorText}>設置個数は必須入力です。</p>}
              {trapErrors?.count?.type === "pattern" && <p className={styles.modalErrorText}>設置個数は半角数字で入力してください。</p>}
            </Field>
            <Field label="履歴緯度" className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...trapRegister("log_lat", { pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 90) && (value >= -90) })}
              />
              {trapErrors?.log_lat?.type === "pattern" && <p className={styles.modalErrorText}>緯度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {trapErrors?.log_lat?.type === "validate" && <p className={styles.modalErrorText}>緯度は-90以上90以下の値を入力して下さい。</p>}
            </Field>
            <Field label="履歴経度" className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...trapRegister("log_lon", { pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 180) && (value >= -180) })}
              />
              {trapErrors?.log_lon?.type === "pattern" && <p className={styles.modalErrorText}>経度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {trapErrors?.log_lon?.type === "validate" && <p className={styles.modalErrorText}>経度は-180以上180以下の値を入力して下さい。</p>}
            </Field>
            <Field label="錯誤捕獲フラグ" className={styles.field}>
              <Radio type="checkbox" value="mistake" {...trapRegister("mistake")} />
            </Field>
            <Field label="錯誤捕獲対象動物" className={styles.field}>
              <Textarea
                rows={3}
                placeholder="例)イノシシ1頭"
                {...trapRegister("mistake_log")}
                disabled={trapWatch("mistake") != "mistake"}
              />
            </Field>
            <Field label="管理者" className={styles.field}>
              <Input
                type="text"
                placeholder="例）●●●さん"
                variant="full"
                {...trapRegister("admin")}
              />
            </Field>
            <Field label="管理者連絡先" className={styles.field}>
              <Input
                type="text"
                placeholder="例）XXX-XXXX-XXXXX"
                variant="full"
                className={styles.width_limit}
                {...trapRegister("admin_tel",{pattern: /^[-,0-9]{1,}$/})}
              />
              {trapErrors?.admin_tel?.type === "pattern" && <p className={styles.modalErrorText}>管理者連絡先はNNN-NNNN-NNNNの形式で入力してください。</p>}
            </Field>
            <Field label="関連カメラID" className={styles.field}>
              <Input
                type="text"
                placeholder="関連カメラIDをご記入ください"
                variant="full"
                className={styles.width_limit}
                {...trapRegister("camera_id",{pattern: /^[0-9]{1,}$/})}
              />
              {trapErrors?.camera_id?.type === "pattern" && <p className={styles.modalErrorText}>カメラIDは半角数字で入力してください。</p>}
            </Field>
            <Field label="公開範囲" required={true} className={styles.field}>
              <Select variant="middle" className={clsx(trapWatch("displayability") === "" && styles.initialValueText)} {...trapRegister("displayability", { required: true, validate: value => value === "公開" || value === "ログイン閲覧者公開" || value === "登録修正論理削除権限者公開" || value === "管理者公開" })} disabled={cookie?.verminData?.user_kind_id !== 3}>
                <option value="" hidden>公開範囲をご選択ください</option>
                <option value="公開">公開</option>
                <option value="ログイン閲覧者公開">ログイン閲覧者公開</option>
                <option value="登録修正論理削除権限者公開">登録修正論理削除権限者公開</option>
                <option value="管理者公開">管理者公開</option>
              </Select>
              {trapErrors?.displayability?.type === "required" && <p className={styles.modalErrorText}>公開範囲は必須入力です</p>}
              {trapErrors?.displayability?.type === "validate" && <p className={styles.modalErrorText}>公開範囲に選択肢以外の回答が入力されています。</p>}
            </Field>
            {trapData &&
              <Field label="削除" className={styles.field}>
                <Radio type="checkbox" value="delete" {...trapRegister("delete")} />
              </Field>
            }
            <Field label="備考" className={styles.field}>
              <Textarea
                rows={3}
                placeholder="備考情報を入力"
                {...trapRegister("remarks")}
              />
            </Field>
            <ButtonsWrap>
              <Button type="button" variant="cancel" onClick={handleCreateTrapModalClose}>
                キャンセル
              </Button>
              <Button type="submit">
                登録
              </Button>
            </ButtonsWrap>
          </Form>
        </Modal>
        {/* カメラ情報登録モーダル */}
        <Modal
          label={verminData ? "カメラ情報編集" : "カメラ情報新規登録"}
          onClick={handleCreateCameraModalClose}
          open={isCreateCameraModal}
          variant="wide"
        >
          <Form onSubmit={cameraSubmit(registerCamera)}>
            <Field label="撮影開始日" className={styles.field}>
              <Controller control={cameraControl}
                name='camera_start' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja}  showMonthDropdown={true} showYearDropdown={true}//230419追加
                    className={clsx(styles.input,styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )} />
            </Field>
            <Field label="撮影終了日" className={styles.field}>
              <Controller control={cameraControl}
                name='camera_stop' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja}  showMonthDropdown={true} showYearDropdown={true}//230419追加
                    className={clsx(styles.input,styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )} />
            </Field>
            <Field label="緯度" required={true} className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...cameraRegister("latitude", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 90) && (value >= -90) })}
              />
              {cameraErrors?.latitude?.type === "required" && <p className={styles.modalErrorText}>緯度は必須入力です</p>}
              {cameraErrors?.latitude?.type === "pattern" && <p className={styles.modalErrorText}>緯度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {cameraErrors?.latitude?.type === "validate" && <p className={styles.modalErrorText}>緯度は-90以上90以下の値を入力して下さい。</p>}
            </Field>
            <Field label="経度" required={true} className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...cameraRegister("longitude", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 180) && (value >= -180) })}
              />
              {cameraErrors?.longitude?.type === "required" && <p className={styles.modalErrorText}>経度は必須入力です</p>}
              {cameraErrors?.longitude?.type === "pattern" && <p className={styles.modalErrorText}>経度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {cameraErrors?.longitude?.type === "validate" && <p className={styles.modalErrorText}>経度は-180以上180以下の値を入力して下さい。</p>}
            </Field>
            <Field label="カメラ向き" /*required={true}*/ className={styles.field}>
              <Input
                type="text"
                placeholder="例)北、罠No.X方向"
                variant="full"
                className={styles.width_limit}
                {...cameraRegister("direction"/*,{required: true}*/)}
              />
            </Field>
            <Field label="関連罠ID" className={styles.field}>
              <Input
                type="text"
                placeholder="関連罠IDをご記入ください"
                variant="full"
                className={styles.width_limit}
                {...cameraRegister("trap_id",{pattern: /^[0-9]{1,}$/})}
              />
              {cameraErrors?.trap_id?.type === "pattern" && <p className={styles.modalErrorText}>カメラIDは半角数字で入力してください。</p>}
            </Field>
            <Field label="公開範囲" required={true} className={styles.field}>
              <Select variant="middle" className={clsx(cameraWatch("displayability") === "" && styles.initialValueText)} {...cameraRegister("displayability", { required: true, validate: value => value === "公開" || value === "ログイン閲覧者公開" || value === "登録修正論理削除権限者公開" || value === "管理者公開" })} disabled={cookie?.verminData?.user_kind_id !== 3}>
                <option value="" hidden>公開範囲をご選択ください</option>
                <option value="公開">公開</option>
                <option value="ログイン閲覧者公開">ログイン閲覧者公開</option>
                <option value="登録修正論理削除権限者公開">登録修正論理削除権限者公開</option>
                <option value="管理者公開">管理者公開</option>
              </Select>
              {cameraErrors?.displayability?.type === "required" && <p className={styles.modalErrorText}>公開範囲は必須入力です</p>}
              {cameraErrors?.displayability?.type === "validate" && <p className={styles.modalErrorText}>公開範囲に選択肢以外の回答が入力されています。</p>}
            </Field>
            {cameraData &&
              <Field label="削除" className={styles.field}>
                <Radio type="checkbox" value="delete" {...cameraRegister("delete")} />
              </Field>
            }
            <Field label="備考" className={styles.field}>
              <Textarea
                rows={3}
                placeholder="備考情報を入力"
                {...cameraRegister("remarks")}
              />
            </Field>
            <ButtonsWrap>
              <Button type="button" variant="cancel" onClick={handleCreateCameraModalClose}>
                キャンセル
              </Button>
              <Button type="submit">
                登録
              </Button>
            </ButtonsWrap>
          </Form>
        </Modal>
        {/* 防止施設情報登録モーダル */}
        <Modal
          label={verminData ? "防止施設情報編集" : "防止施設情報新規登録"}
          onClick={handleCreatePrevModalClose}
          open={isCreatePrevModal}
          variant="wide"
        >
          <Form onSubmit={prevSubmit(registerPrev)}>
          <Field label="防止施設種別" required={true} className={styles.field}>
              <Select variant="middle" {...prevRegister("type_name", { required: true })}>
                <option value="" hidden>防止施設種別をご選択ください</option>
                <option value="電気柵">電気柵</option>
                <option value="ワイヤーメッシュ">ワイヤーメッシュ</option>
                <option value="複合柵">複合柵</option>
                <option value="その他">その他</option>
              </Select>
              {prevErrors?.type_name?.type === "validate" && <p className={styles.modalErrorText}>防止施設種別に選択肢以外の回答が入力されています。</p>}
              {prevErrors?.type_name?.type === "required" && <p className={styles.modalErrorText}>防止施設種別は必須入力です</p>}
            </Field>
            <Field label="交付年月日" className={styles.field}>
              <Controller control={prevControl}
                name='delivery_date' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja}  showMonthDropdown={true} showYearDropdown={true}//230419追加
                    className={clsx(styles.input,styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )} />
            </Field>
            <Field label="交付年度" className={styles.field}>
              <Input
                type="text"
                placeholder="例）令和3年、西暦2021年"
                variant="full"
                className={styles.width_limit}
                {...prevRegister("delivery_year")}
              />
            </Field>
            <Field label="管理者" className={styles.field}>
              <Input
                type="text"
                placeholder="例）T市農業企画課農業被害対策係"
                variant="full"
                className={styles.width_limit}
                {...prevRegister("admin")}
              />
            </Field>
            <Field label="連絡先" className={styles.field}>
              <Input
                type="text"
                placeholder="例）XXX-XXXX-XXXX"
                variant="full"
                className={styles.width_limit}
                {...prevRegister("admin_tel")}
              />
            </Field>
            <Field label="住所" className={styles.field}>
              <Input
                type="text"
                placeholder="例）A神社の裏山"
                variant="full"
                className={styles.width_limit}
                {...prevRegister("adress")}
              />
            </Field>
            <Field label="防止施設距離(単位はkmもしくはm)(単位が未記入時はmとなる)" className={styles.field}>
              <Input
                type="text"
                placeholder="例）7.6km,5m"
                variant="full"
                className={styles.width_limit}
                {...prevRegister("distance",{pattern: /^[0-9]+[.]{0,1}[0-9]*[k]{0,1}[m]{0,1}$/})}
              />
              {prevErrors?.distance?.type === "pattern" && <p className={styles.modalErrorText}>防止施設距離は、XXX(km or m)と入力してください。</p>}
            </Field>
            <Field label="防止施設位置情報" required={true} className={styles.field}>
              <Button onClick={prevOpenLine}>
                位置情報登録
              </Button>
              {Line != null && <div>防止設備位置情報が登録されました。</div>}
              {Line == null && <div>防止設備位置情報が登録されておりません。</div>}
              {(Line == null && prevWatch("geom_text")=="更新") && <div>登録しなかった時、防止位置情報は更新されません。
                <br />更新する際は、防止位置情報は最初からの登録となります。</div>}
              <Button onClick={prevCloseLine} disabled={Line==null}>
                  位置情報削除
              </Button>
              <p id="Line_Error" className={styles.modalErrorText}></p>
            </Field>
            <Field label="公開範囲" required={true} className={styles.field}>
              <Select variant="middle" className={clsx(prevWatch("displayability") === "" && styles.initialValueText)} {...prevRegister("displayability", { required: true, validate: value => value === "公開" || value === "ログイン閲覧者公開" || value === "登録修正論理削除権限者公開" || value === "管理者公開" })} disabled={cookie?.verminData?.user_kind_id !== 3}>
                <option value="" hidden>公開範囲をご選択ください</option>
                <option value="公開">公開</option>
                <option value="ログイン閲覧者公開">ログイン閲覧者公開</option>
                <option value="登録修正論理削除権限者公開">登録修正論理削除権限者公開</option>
                <option value="管理者公開">管理者公開</option>
              </Select>
              {prevErrors?.displayability?.type === "required" && <p className={styles.modalErrorText}>公開範囲は必須入力です</p>}
              {prevErrors?.displayability?.type === "validate" && <p className={styles.modalErrorText}>公開範囲に選択肢以外の回答が入力されています。</p>}
            </Field>
            {prevData &&
              <Field label="削除" className={styles.field}>
                <Radio type="checkbox" value="delete" {...prevRegister("delete")} />
              </Field>
            }
            <Field label="備考" className={styles.field}>
              <Textarea
                rows={3}
                placeholder="備考情報を入力"
                {...prevRegister("remarks")}
              />
            </Field>
            <ButtonsWrap>
              <Button type="button" variant="cancel" onClick={handleCreatePrevModalClose}>
                キャンセル
              </Button>
              <Button type="submit">
                登録
              </Button>
            </ButtonsWrap>
          </Form>
        </Modal>
        {/* 指示ピン情報登録モーダル */}
        <Modal
          label={indpinData ? "指示ピン編集" : "指示ピン新規登録"}
          onClick={handleCreateIndpinModalClose}
          open={isCreateIndpinModal}
          variant="wide"
        >
          <Form onSubmit={indpinSubmit(registerIndpin)}>
            <Field label="ラベル(地図上表示半角数字)" required={true} className={styles.field}>
            <Input
                type="text"
                placeholder="例）12"
                variant="full"
                className={styles.width_limit}
                {...indpinRegister("label", { required: true, pattern: /^[+-]?[0-9]{1,}$/ })}
              />
              {indpinErrors?.label?.type === "pattern" && <p className={styles.modalErrorText}>ラベルの入力は半角数字です</p>}
              {indpinErrors?.label?.type === "required" && <p className={styles.modalErrorText}>ラベルは必須入力です</p>}
            </Field>
            <Field label="緯度" required={true} className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...indpinRegister("latitude", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 90) && (value >= -90) })}
              />
              {indpinErrors?.latitude?.type === "required" && <p className={styles.modalErrorText}>緯度は必須入力です</p>}
              {indpinErrors?.latitude?.type === "pattern" && <p className={styles.modalErrorText}>緯度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {indpinErrors?.latitude?.type === "validate" && <p className={styles.modalErrorText}>緯度は-90以上90以下の値を入力して下さい。</p>}
            </Field>
            <Field label="経度" required={true} className={styles.field}>
              <Input
                type="text"
                placeholder="dddd.ddddd"
                variant="full"
                className={styles.width_limit}
                {...indpinRegister("longitude", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 180) && (value >= -180) })}
              />
              {indpinErrors?.longitude?.type === "required" && <p className={styles.modalErrorText}>経度は必須入力です</p>}
              {indpinErrors?.longitude?.type === "pattern" && <p className={styles.modalErrorText}>経度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {indpinErrors?.longitude?.type === "validate" && <p className={styles.modalErrorText}>経度は-180以上180以下の値を入力して下さい。</p>}
            </Field>
            {/* 指示ピンコメント 20250417 Add Uduki */}
            <Field label="コメント" className={styles.field}>
              <Textarea
                rows={1}
                placeholder="コメントを入力"
                {...indpinRegister("comment")}
              />
            </Field>
            <Field label="公開範囲" required={true} className={styles.field}>
              <Select variant="middle" className={clsx(indpinWatch("displayability") === "" && styles.initialValueText)} {...indpinRegister("displayability", { required: true, validate: value => value === "公開" || value === "ログイン閲覧者公開" || value === "登録修正論理削除権限者公開" || value === "管理者公開" })} disabled={cookie?.verminData?.user_kind_id !== 3}>
                <option value="" hidden>公開範囲をご選択ください</option>
                <option value="公開">公開</option>
                <option value="ログイン閲覧者公開">ログイン閲覧者公開</option>
                <option value="登録修正論理削除権限者公開">登録修正論理削除権限者公開</option>
                <option value="管理者公開">管理者公開</option>
              </Select>
              {indpinErrors?.displayability?.type === "required" && <p className={styles.modalErrorText}>公開範囲は必須入力です</p>}
              {indpinErrors?.displayability?.type === "validate" && <p className={styles.modalErrorText}>公開範囲に選択肢以外の回答が入力されています。</p>}
            </Field>
            {indpinData &&
              <Field label="削除" className={styles.field}>
                <Radio type="checkbox" value="delete" {...indpinRegister("delete")} />
              </Field>
            }
            <ButtonsWrap>
              <Button type="button" variant="cancel" onClick={handleCreateIndpinModalClose}>
                キャンセル
              </Button>
              <Button type="submit">
                登録
              </Button>
            </ButtonsWrap>
          </Form>
        </Modal>
        {/* 拡大画像モーダル 画像登録用20230411追記 */}
        <Modal
          label="画像拡大表示"
          onClick={handlePicturenModalToggle}
          open={isExpPictureModal}
          variant="wide"
        >
          <img src={ExpImage} /*style={{minHeight:"150px",minWidth:"150px"}}*/></img>
        </Modal>
        {/* 報告書編集モーダル Add Uduki 20240410*/}
        <Modal
          label="有害鳥獣出没現地確認報告書編集"
          onClick={handleCreateReportModalClose}
          open={isCreateReportModal}
          variant="wide"
        >
          <Form onSubmit={reportSubmit(registerReport)}>
          <Input type="hidden" {...reportRegister("report_kind")} disabled={true} />
          <Input type="hidden" {...reportRegister("information_id")} disabled={true} />

          <Field label="報告日" required={true} className={styles.field}>
              <Controller control={reportControl}
                name='report_dt' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja} showMonthDropdown={true} showYearDropdown={true}//230419追加
                    className={clsx(styles.input,styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )}
              />
              {errors?.report_dt?.length !== 0 && errors?.report_dt?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
              {reportErrors?.report_dt?.type === "required" && <p className={styles.modalErrorText}>報告日は必須入力です</p>}
            </Field>
            <Field label="受付者" required={true} className={styles.field}>
            <Input type="text" variant="full" placeholder="受付者ををご記入ください" className={styles.width_limit}
                {...reportRegister("receptionist_nm")} />
              {reportErrors?.receptionist_nm?.type === "required" && <p className={styles.modalErrorText}>受付者は必須入力です</p>}
            </Field>
            <Field label="報告者氏名 (受領者と報告者が異なる場合入力ください)" className={styles.field}>
            <Input type="text" variant="full" placeholder="報告者氏名ををご記入ください" className={styles.width_limit}
                {...reportRegister("reporter_nm")} />
            </Field>
            <Field label="経由" className={styles.field}>
              <Textarea rows={1} placeholder="経由情報をご記入ください"
                {...reportRegister("waypoint")} />
            </Field>
            <Field label="通報受付日" className={styles.field}>
              <Controller control={reportControl}
                name='receptionist_dt' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja} showMonthDropdown={true} showYearDropdown={true}
                    className={clsx(styles.input,styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )} />
              {errors?.receptionist_dt?.length !== 0 && errors?.receptionist_dt?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>
            <Field label="通報受付時刻" className={styles.field}>
              <Controller control={reportControl}
                name='receptionist_tm' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="HH:mm"
                    showTimeSelect showTimeSelectOnly timeCaption="Time"
                    locale={ja}
                    className={clsx(styles.input,styles.width_limit)} placeholderText='00:00' selected={value as unknown as Date} />
                )} />
              {errors?.receptionist_tm?.length !== 0 && errors?.receptionist_tm?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>

            <Field label="通報者氏名" className={styles.field}>
            <Input type="text" variant="full" placeholder="通報者氏名ををご記入ください" className={styles.width_limit}
                {...reportRegister("report_nm")} />
            </Field>
            <Field label="通報者電話番号" className={styles.field}>
            <Input type="text" variant="full" placeholder="通報者電話番号をご記入ください" className={styles.width_limit}
                {...reportRegister("report_tel", { pattern: /^([0-9]{0,}|[0-9]{3,4}-[0-9]{2,4}-[0-9]{4})$/ })} />
                {reportErrors?.report_tel?.type === "pattern" && <p className={styles.modalErrorText}>通報者電話番号はNNNNNNNNNNNかNNN(N)-NN(NN)-NNNN形式で入力してください。</p>}
            </Field>
            <Field label="認知日" className={styles.field}>
              <Controller control={reportControl}
                name='discovery_dt' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja} showMonthDropdown={true} showYearDropdown={true}
                    className={clsx(styles.input,styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )} />
              {errors?.discovery_dt?.length !== 0 && errors?.receptionist_dt?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>
            <Field label="認知時刻" className={styles.field}>
              <Controller control={reportControl}
                name='discovery_tm' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="HH:mm"
                    showTimeSelect showTimeSelectOnly timeCaption="Time"
                    locale={ja}
                    className={clsx(styles.input,styles.width_limit)} placeholderText='00:00' selected={value as unknown as Date} />
                )} />
              {errors?.discovery_tm?.length !== 0 && errors?.discovery_tm?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>
            <Field label="認知場所 住所" className={styles.field}>
            <Input type="text" variant="full" placeholder="例)●●●町付近"
                {...reportRegister("discovery_address")} />
            </Field>
            <Field label="緯度" required={true} className={styles.field}>
              <Input type="text" placeholder="dddd.ddddd" variant="full" className={styles.width_limit}
                {...reportRegister("latitude", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 90) && (value >= -90) })}
              />
              {reportErrors?.latitude?.type === "required" && <p className={styles.modalErrorText}>緯度は必須入力です</p>}
              {reportErrors?.latitude?.type === "pattern" && <p className={styles.modalErrorText}>緯度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {reportErrors?.latitude?.type === "validate" && <p className={styles.modalErrorText}>緯度は-90以上90以下の値を入力して下さい。</p>}
            </Field>
            <Field label="経度" required={true} className={styles.field}>
              <Input type="text" placeholder="dddd.ddddd" variant="full" className={styles.width_limit}
                {...reportRegister("longitude", { required: true, pattern: /^[+-]?[0-9]+\.[0-9]{1,}$/, validate: value => (value <= 180) && (value >= -180) })}
              />
              {reportErrors?.longitude?.type === "required" && <p className={styles.modalErrorText}>経度は必須入力です</p>}
              {reportErrors?.longitude?.type === "pattern" && <p className={styles.modalErrorText}>経度はNNNN.NNNNNN(十進法)の形式で入力してください。</p>}
              {reportErrors?.longitude?.type === "validate" && <p className={styles.modalErrorText}>経度は-180以上180以下の値を入力して下さい。</p>}
            </Field>
            <Field label="行政区" className={styles.field}>
            <Input type="text" variant="full" placeholder="行政区名をご記入ください"
                {...reportRegister("administrative_district")} />
            </Field>
            <Field label="害獣種別" required={true} className={styles.field}>
              <Select variant="middle" className={clsx(reportWatch("vermin_kind_id") === "" && styles.initialValueText)}
              {...reportRegister("vermin_kind_id", 
                { required: true, validate: (value) => vermin_category.hasOwnProperty(value)})}>
                <option value={undefined} hidden>害獣種別をご選択ください</option>
                {Object.entries(vermin_category).map((value) => {
                  return(<option value={value[0]}>{value[1]}</option>);})}
              </Select>
              {reportErrors?.vermin_kind_id?.type === "validate" && <p className={styles.modalErrorText}>害獣種別に選択肢以外の回答が入力されています。</p>}
              {reportErrors?.vermin_kind_id?.type === "required" && <p className={styles.modalErrorText}>害獣種別は必須入力です</p>}
            </Field>
            <Field label="頭数">
              <div className={styles.fieldRow}>
                <Input type="text" placeholder="頭数をご記入ください(不明時は未記入)" variant="middle"
                  {...reportRegister("head_count", { pattern: /^[0-9]{0,}$/ })} />
                <p className={styles.labelText}> 頭 </p>
              </div>
              {reportErrors?.head_count?.type === "pattern" && <p className={styles.modalErrorText}>頭数は半角数字で入力してください。</p>}
            </Field>
            <Field label="情報分類" required={true} className={styles.field}>
              {reportWatch("report_kind") == 1 &&
              <Select variant="middle" className={clsx(reportWatch("ecology")  == undefined && styles.initialValueText)}
              {...reportRegister("ecology", 
                { required: true, validate: (value) => ecology.hasOwnProperty(value)})}>
                <option value={undefined}  hidden>情報分類をご選択ください</option>
                {Object.values(ecologyDisplayOrder).map((value) => {
                  return(<option value={value}>{ecology[value]}</option>);})}
              </Select>}
              {reportWatch("report_kind") == 2 &&
              <Select variant="middle" className={clsx(reportWatch("ecology")  == undefined && styles.initialValueText)}
              {...reportRegister("ecology", 
                { required: true, validate: (value) => value == 1 || value == 2 || value == 4 || value == 5})}>
                <option value={undefined}  hidden>情報分類をご選択ください</option>
                <option value={1}>防止施設被害</option> <option value={2}>農産物被害</option>
                <option value={4}>人的被害</option> <option value={5}>生活環境被害</option>
              </Select>}
              {reportErrors?.ecology?.type === "validate" && <p className={styles.modalErrorText}>情報分類に選択肢以外の回答が入力されています。</p>}
              {reportErrors?.ecology?.type === "required" && <p className={styles.modalErrorText}>情報分類は必須入力です</p>}
            </Field>
            <Field label="通報状況" className={styles.field}>
              <Textarea rows={3} placeholder="通報された状況をご記入ください"
                {...reportRegister("report_st")} />
            </Field>

            <Field label="現地確認日" className={styles.field}>
              <Controller control={reportControl}
                name='confirmation_dt' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="yyyy/MM/dd"
                    locale={ja} showMonthDropdown={true} showYearDropdown={true}
                    className={clsx(styles.input,styles.width_limit)} placeholderText='カレンダーから選択' selected={value as unknown as Date} />
                )} />
              {errors?.confirmation_dt?.length !== 0 && errors?.confirmation_dt?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>
            <Field label="現地確認時刻" className={styles.field}>
              <Controller control={reportControl}
                name='confirmation_tm' render={({ field: { onChange, value } }) => (
                  <DatePicker onChange={onChange} dateFormat="HH:mm"
                    showTimeSelect showTimeSelectOnly timeCaption="Time"
                    locale={ja}
                    className={clsx(styles.input,styles.width_limit)} placeholderText='00:00' selected={value as unknown as Date} />
                )} />
              {errors?.confirmation_tm?.length !== 0 && errors?.confirmation_tm?.map((value) => <p className={styles.modalErrorText}>{value}</p>)}
            </Field>
            <Field label="確認者氏名" className={styles.field}>
              <Input type="text" variant="full" placeholder="確認者氏名ををご記入ください" className={styles.width_limit}
                {...reportRegister("confirmer")} />
            </Field>
            <Field label="立会者者氏名" className={styles.field}>
              <Input type="text" variant="full" placeholder="立会者氏名ををご記入ください" className={styles.width_limit}
                {...reportRegister("witness")} />
            </Field>
            <Field label="立会者電話番号" className={styles.field}>
              <Input type="text" variant="full" placeholder="立会者電話番号をご記入ください" className={styles.width_limit}
                {...reportRegister("witness_tel", { pattern: /^([0-9]{0,}|[0-9]{3,4}-[0-9]{2,4}-[0-9]{4})$/ })} />
                {reportErrors?.witness_tel?.type === "pattern" && <p className={styles.modalErrorText}>立会者電話番号はNNNNNNNNNNNかNNN(N)-NN(NN)-NNNN形式で入力してください。</p>}
            </Field>
            <Field label="出没ゾーニング" className={styles.field}>
              <Select variant="middle" className={clsx(reportWatch("zoning") == undefined && styles.initialValueText)} {...reportRegister("zoning", { validate: (value) => value == 1 || value == 2 || value == 3 || value == 0})}>
                <option value={0}>出没ゾーニングをご選択ください</option>
                <option value={1}>生息地帯</option>
                <option value={2}>緩衝地帯</option>
                <option value={3}>人の生活圏</option>
              </Select>
              {reportErrors?.zoning?.type === "validate" && <p className={styles.modalErrorText}>出没ゾーニングに選択肢以外の回答が入力されています。</p>}
            </Field>
            <Field label="現地状況・対応内容" className={styles.field}>
              <Textarea rows={3} placeholder="確認した現地の状況や対応内容をご記入ください"
                {...reportRegister("zoning_st")} />
            </Field>

            <Field label="関係機関への連絡" className={styles.field}>
              <Textarea rows={3} placeholder="関係機関への連絡状況をご記入ください"
                {...reportRegister("contact_rp")} />
            </Field>

            {(reportWatch("report_kind") == 2 && reportWatch("ecology") == 4) &&
              <Field label="人的被害_詳細" className={styles.field}>
                <Textarea rows={3} placeholder="被害の詳細をご記入ください" 
                {...reportRegister("hdamage_nt")} />
              </Field>
            }
            {(reportWatch("report_kind") == 2 && reportWatch("ecology") == 2) &&
            <span>
              <Field label="農作物被害_作物名" className={styles.field}>
                <Input type="text" variant="full" placeholder="農作物名をご記入ください" className={styles.width_limit}
                  {...reportRegister("crop_nm")} />
              </Field>
              <Field label="農作物被害_自家用・出荷用" className={styles.field}>
                <Radio type="checkbox" value="1" {...reportRegister('new_crop_ps')}>
                    自家用
                </Radio>
                <Radio type="checkbox" value="2" {...reportRegister('new_crop_ps')}>
                    出荷用
                </Radio>
             </Field>
             <Field label="農作物被害_数量(単位含む)" className={styles.field}>
                <Input type="text" variant="full" placeholder="被害数量をご記入ください"
                  {...reportRegister("crop_co")} />
              </Field>
              <Field label="農作物被害_被害面積(単位含む)" className={styles.field}>
                <Input type="text" placeholder="被害面積をご記入ください" variant="full" className={styles.width_limit}
                  {...reportRegister("crop_ar")}
                />
              </Field>
              <Field label="農作物被害_特筆事項" className={styles.field}>
                <Textarea rows={3} placeholder="農作物被害で特筆事項がある時はご記入ください"
                  {...reportRegister("crop_nt")} />
              </Field>
            </span>
            }
            {(reportWatch("report_kind") == 1 && reportWatch("ecology") == 8) &&
            <span>
              <Field label="掘り起こし_深さ(cm)" className={styles.field}>
                <Input type="text" placeholder="dd.dd" variant="full" className={styles.width_limit}
                  {...reportRegister("digging_up_dp", { pattern: /^[0-9]{1,}(\.[0-9]{1,}){0,1}$/ })}
                />
                <p className={styles.labelText}> cm </p>
                {reportErrors?.digging_up_dp?.type === "pattern" && <p className={styles.modalErrorText}>掘り起しの深さは、半角数字で入力してください。</p>}
              </Field>
              <Field label="掘り起し_特筆事項" className={styles.field}>
                <Textarea rows={3}  placeholder="掘り起し被害で特筆事項がある時はご記入ください"
                {...reportRegister("digging_up_nt")} />
              </Field>
            </span>
            }
            <Field label="その他_被害内容" className={styles.field}>
              <Textarea rows={3} placeholder="その他の被害内容をご記入ください"
                {...reportRegister("damage_other")} />
            </Field>

            <Field label="添付資料" className={styles.field}>
                <Radio type="checkbox" value="1" {...reportRegister('new_attachKind')}>
                    位置図
                </Radio>
                <Radio type="checkbox" value="2" {...reportRegister('new_attachKind')}>
                    写真
                </Radio>
                <Radio type="checkbox" value="4" {...reportRegister('new_attachKind')} onChange={attach_other_change}>
                    その他ファイル
                </Radio>
            </Field>

            <Field label="その他添付資料" className={styles.field} id='attach_other'>
              <Input type="text" variant="full" placeholder="その他添付資料の詳細をご記入ください"
                {...reportRegister("attach_other_r")} />
              </Field>

            <Field label="備考" className={styles.field}>
              <Textarea rows={3} placeholder="備考情報をご記入ください" {...reportRegister("remarks")} />
            </Field>
            <ButtonsWrap>
              <Button type="button" variant="cancel" onClick={handleCreateReportModalClose}>
                キャンセル
              </Button>
              <Button type="submit">
                登録/PDF出力
              </Button>
            </ButtonsWrap>
          </Form>
        </Modal>
        {/**
       * ↓↓↓ サイドバー ↓↓↓
      */}
        <Sidebar isVisible={sidebarVisible} onClick={handleSidebarClose}>
          {!cookie.verminData ?
            <form className={styles.loginForm} onSubmit={loginSubmit(handleLogin)}>
              <p className={styles.loginText}>
                メニューの利用にはログインが必要です
              </p>
              <label htmlFor="" className={styles.loginLabel}>
                ユーザーID
                <Input variant='middle' {...loginRegister("userId", { required: true })}></Input>
              </label>
              <label htmlFor="" className={styles.loginLabel}>
                パスワード
                <Input variant='middle' type="password" {...loginRegister("password", { required: true })}></Input>
              </label>
              <Button variant='primary' type="submit">ログイン</Button>
              {(loginErrors?.userId?.type === "required" || loginErrors?.password?.type === "required") && <p className={styles.loginErrorText}>ユーザーIDまたはパスワードは必須入力です</p>}
              {loginError?.password?.length !== 0 &&
                loginError?.password?.map(
                  (value: string) =>
                    <p className={styles.loginErrorText}>{value}</p>
                )
              }
              {loginError?.user_login_id?.length !== 0 &&
                loginError?.user_login_id?.map(
                  (value: string) =>
                    <p className={styles.loginErrorText}>{value}</p>
                )
              }
              <div onClick={PassReset} className={styles.LayoutBG} style={{marginTop: "15px"}}><IconUsers /><div style={{marginLeft: "15px",display:"inline"}}>パスワード再設定</div></div>
            </form>
            :
            <List>
              <List.Item path="/" title="マップ"><IconMap /></List.Item>
            {Number(cookie?.verminData?.user_kind_id)>1&&<List.Item path="/Data" title="データ管理"><IconData /></List.Item>}
            {Number(cookie?.verminData?.user_kind_id)>1&&<List.Item path="/Chart" title="グラフ表示"><IconData /></List.Item>}
            {/*{Number(cookie?.verminData?.user_kind_id)>1&&<List.Item path="/Data" title="データ管理"><IconData /></List.Item>}*/}
            {Number(cookie?.verminData?.user_kind_id)>2&&<List.Item path="/Import" title="データ取り込み"><IconImport /></List.Item>}
            {/*Number(cookie?.verminData?.user_kind_id)>2&&<List.Item path="/Tenant" title="テナント管理"><IconTenant /></List.Item>*/}
            {Number(cookie?.verminData?.user_kind_id)>2&&<div onClick={ClientEdit} className={styles.LayoutBG}><IconTenant /><div style={{marginLeft: "15px",display:"inline"}}>テナント管理</div></div>}
            {Number(cookie?.verminData?.user_kind_id)>2&&<div onClick={UserIndex} className={styles.LayoutBG}><IconUsers /><div style={{marginLeft: "15px",display:"inline"}}>ユーザー管理</div></div>}
            {/*Number(cookie?.verminData?.user_kind_id)>2&&<div onClick={ClientEdit} className={styles.LayoutBG}><IconUsers /><div style={{marginLeft: "15px",display:"inline"}}>クライアント情報変更</div></div>*/}
            {Number(cookie?.verminData?.user_kind_id)>2&&<div onClick={DisResIndex} className={styles.LayoutBG}><IconTenant /><div style={{marginLeft: "15px",display:"inline"}}>地区・宛先情報管理</div></div>}
            {Number(cookie?.verminData?.user_kind_id)>2&&<div onClick={TempIndex} className={styles.LayoutBG}><IconTenant /><div style={{marginLeft: "15px",display:"inline"}}>テンプレート管理</div></div>}
            {/*(Number(cookie?.verminData?.user_kind_id)>2 && cookie?.verminData?.client_code==1380001004696)&&<div onClick={NewClientEdit} className={styles.LayoutBG}><IconUsers /><div style={{marginLeft: "15px",display:"inline"}}>全テナント管理</div></div>230707コメアウト
            {Number(cookie?.verminData?.user_kind_id)>3&&<div onClick={NewClientEdit} className={styles.LayoutBG}><IconUsers /><div style={{marginLeft: "15px",display:"inline"}}>テナント作製</div></div>230707コメントアウト*/}
            <div onClick={PassChange} className={styles.LayoutBG}><IconSetting /><div style={{marginLeft: "15px",display:"inline"}}>パスワード変更</div></div>
            <List.Item path="/Download" title="ダウンロード"><IconSetting /></List.Item>
            {/*<List.Item path="/Setting" title="設定"><IconSetting /></List.Item>*/}
            </List>
          }
        </Sidebar>

        <div className={clsx(styles.container, sidebarVisible && styles.sidebar)}>
          <header className={clsx(styles.header, isDroped && styles.isActive, location.pathname !== "/" && styles.row)}>
            <div className={styles.headerLeft}>

              <Button variant="hamburger" className={styles.button} aria-label="サイドバーを開く" onClick={handleSidebarToggle}>
                <IconHamburger />
              </Button>
              <div className={styles.inner}>
                <h1 className={styles.headerTitle}>
                  <img src={logoSite2} width="30" height="30"/>
                  <img src={pagetitle} className={styles.p_title}/>
                </h1>
                {/* <h1 className={styles.logo}>
                <img src={logoSite} alt="鳥獣害対策マップ" width="231" height="40" />
              </h1> */}
                {/*<a href='http://192.168.56.10/make/index'>メインメニュー/ログイン</a>*/}
                {/* <a href='http://www.habitat-explore.com/make/index'>メインメニュー/ログイン</a>
            <Button
            variant="icon"
            className={styles.button}
            aria-label="データ出力モーダルを開く"
            onClick={handleDataOutputModalToggle}
            >
            <IconDownload />
          </Button> */}
              </div>
              {cookie?.verminData?.user_info_name &&
                <button type="button" onClick={() => setIsLogoutModal(!isLogoutModal)} className={styles.logoutButton}>
                  <IconUser />
                  <p className={styles.logoutText}>
                    {cookie?.verminData?.user_info_name}
                  </p>
                  <div className={clsx(styles.modalCard, isLogoutModal && styles.isLogoutModal)}>
                    <p >ユーザー名</p>
                    <p className={styles.modalTitle}>{cookie?.verminData?.user_info_name}</p>
                    <p>
                      所在
                    </p>
                    <p className={styles.modalTitle}>
                      {cookie?.verminData?.client_name}
                    </p>
                    <div className={styles.modalFooter}>
                      <Button onClick={handleLogout} variant="cancel">ログアウト</Button>
                    </div>
                  </div>
                </button>
              }
              <Button
                variant="icon"
                className={clsx(styles.button, location.pathname !== "/" && styles.opacity)}
                aria-label="新規登録モーダルを開く"
                onClick={setEditModeToggle}
                disabled={cookie?.verminData?.user_kind_id === 1 || !cookie?.verminData}
              >
                <IconMessageAdd />
              </Button>
            </div>
            <SearchForm className={clsx(styles.search, location.pathname !== "/" && styles.opacity)} />
          </header>
          <div className={clsx(styles.contents, location.pathname !== "/" && styles.vh)}>
            {children}
          </div>
        </div>
      </div >
      {loading &&
        <div className={styles.modalWrapper}>
          <div className={styles.modalOverlay}>
            <Oval
              ariaLabel="loading-indicator"
              height={75}
              width={75}
              strokeWidthSecondary={1}
              color="#3a6468"
              secondaryColor="white"
            />
          </div>
        </div>
      }
    </>
  );
};

export default React.memo(Layout);
